import {
  Component,
  OnInit,
  Input,
  ViewChild,
  ElementRef,
  TemplateRef,
} from "@angular/core";
import {
  Http,
  Headers,
  RequestOptions,
  ResponseContentType,
} from "@angular/http";
import { HttpClient } from "@angular/common/http";
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { PMS } from "../preventive-maintenance/pms-service";
import { Pipe } from "@angular/core";
import {
  ToastyService,
  ToastyConfig,
  ToastOptions,
  ToastData,
} from "ng2-toasty";
declare var $: any;
import { IOption } from "ng-select";
import * as moment from "moment/moment";
import { AuthPublicService } from "../auth.service";
import {
  FileUploader,
  FileSelectDirective,
} from "ng2-file-upload/ng2-file-upload";
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from "./../alert/alert.component";
import { saveAs } from "file-saver";
import { Popup } from "ng2-opd-popup";

interface IMultiSelectOption {
  id?: string | number;
  name?: string;
  [key: string]: any;
}

@Component({
  selector: "app-preventive-maintenance",
  templateUrl: "./preventive-maintenance.component.html",
  styleUrls: ["./preventive-maintenance.component.scss"],
})
export class PreventiveMaintenanceComponent implements OnInit {
  ListPmaCategoryDetails = [];
  PmaCategory: any;
  pmacategoryerr: boolean = false;
  PmaCategoryplaceholder = "PMA CATEGORY";
  PmaCategoryDropdown: Array<IOption> = [];
  emiratesedit: string = "SELECT THE EMIRATES";
  FileShow: any;
  TravelCostValuearr: any;
  TravelcostValue: number = 0;
  emiratesOptions: Array<IOption> = [];
  subLocalityedit: string = "SELECT THE SUBLOCALITY";
  subLocalityOptions: Array<IOption> = [];
  Tooltipmessage: any = "Edit allow only when service is updated";
  SerialNumberDropdown: Array<IOption> = [];
  latlong: Array<{ latitude: number; longitude: number }> = [];
  fileName: Blob = null;
  fileToUpload: File = null;
  downloaderr: boolean = false;
  loading: boolean = true;
  ClientNamePlaceholder = "CHOOSE CLIENT NAME";
  ServiceContractyearsPlaceholder = "SERVICE CONTRACT YEARS";
  MakePlaceholder = "CHOOSE THE MAKE";
  ModelPlaceholder = "CHOOSE THE MODEL";
  ServiceRemainderPlaceholder = "SERVICE REMAINDER DAYS";
  TechnicianNamePlaceholder = "CHOOSE TECHNICIAN NAME";
  LastServiceTypePlaceholder = "LAST SERVICE TYPE";
  YearofManufacturePlaceholder = "YEAR OF MANUFACTURE";
  ServiceContracttplaceholder = "SERVICE CONTRACT OFFERED YEAR";
  BranchPlaceholder = "CHOOSE THE BRANCH";
  ScheduleServiceTypePlaceholder = "SCHEDULE SERVICE TYPE";
  noofServicesofCount: number = null;
  noofservicecontractYears: Array<IOption> = [];
  noofserviceRemainderdays: Array<IOption> = [];
  intervalerr: boolean = false;
  originalenddateerr: boolean = false;
  ListofCustomermasterdropdown: Array<IOption> = [];
  BranchDropDown: Array<IOption> = [];
  techinicianDetails: Array<IOption> = [];
  ListlastServiceType: Array<IOption> = [];
  ListServiceType: Array<IOption> = [];
  ListCustomerdetails: Array<IOption> = [];
  Makedropdown: Array<IOption> = [];
  Modeldropdown: Array<IOption> = [];
  yearOptions: Array<IOption> = [];
  serviceContractYearOptions: Array<IOption> = [];
  lastservicetypeOption: Array<IOption> = [];
  ScheduleservicetypeOption: Array<IOption> = [];
  msgtext: string;
  interval: any = "";
  ListTechnicianName: any[] = [];
  ListOfCheckListMaster: any[] = [];
  ListOfCustomermaster: any[] = [];
  ListOfFields: any[] = [];
  ListOfSecondFields: any[] = [];
  clientName: any;
  serialnumber: any;
  mclocation: any;
  noofService: any;
  startdate: any;
  endDate: any;
  make: any;
  intervalofservice: any;
  model: any;
  hmrHours: any;
  technicianName: any;
  lastServiceType: any;
  lastServiceHour: any;
  yearofmanufacturer: any;
  branch: any;
  serviceContractOffered: any;
  contractReference: any;
  clientPhonenumber: any;
  email: any;
  ListSerialNumber: any[] = [];
  textField: boolean = true;
  dropdownField: boolean = false;
  getListClientdetails: any[] = [];
  showModal: boolean = false;
  chooseClientname: any;
  dialogConfirmation: any;
  nextDate: any;
  disabled: boolean = true;
  SYdisabled: boolean = true;
  isValid: boolean = true;
  serviceRemainderDays: any;
  noofServiceContractYear: any;
  serialNumbererr: boolean = false;
  serialNumbercounterr: boolean = false;
  phonenumbererr: boolean = false;
  phonenumberconuterr: boolean = false;
  modelerr: boolean = false;
  modelcounterr: boolean = false;
  clienterr: boolean = false;
  mcLocationerr: boolean = false;
  noOfserviceerr: boolean = false;
  startdateerr: boolean = false;
  enddateerr: boolean = false;
  makeerr: boolean = false;
  intervalofserviceerr: boolean = false;
  hmrHourserr: boolean = false;
  technicianNameerr: boolean = false;
  lastServiceTypeerr: boolean = false;
  lastServiceHourerr: boolean = false;
  yearofmanufactureerr: boolean = false;
  brancherr: boolean = false;
  serviceContractOfferederr: boolean = false;
  contractReferenceerr: boolean = false;
  emailerr: boolean = false;
  Validemail_err: boolean = false;
  yearofmanufacturecounterr: boolean = false;
  noOFServiceContractYearerr: boolean = false;
  newClientName: any;
  newPhoneNumber: any;
  newEmail: any;
  newClient_err: boolean = false;
  newEmail_err: boolean = false;
  phoneNumber_err: boolean = false;
  onlyNumber_err: boolean = false;
  rangeNumber_err: boolean = false;
  ListMakeDetails: any[] = [];
  ListModelDetails: any[] = [];
  newMake_err: boolean = false;
  newModel_err: boolean = false;
  hmrHourscounterr: boolean = false;
  noOFServiceContractYearCounterr: boolean = false;
  noOfserviceCounterr: boolean = false;
  serviceremainderdays_err: boolean = false;
  serviceremainderdaysCount_err: boolean = false;
  newmake: any;
  newmodel: any;
  newmakeCount: number = 1;
  newmodelCount: number = 1;
  currentQuantity: number = 0;
  currentUnitPrice: number = 0;
  serialNumberAlreadyExisterr: boolean = false;
  lastServiceHourCounterr: boolean = false;
  getSerialNumber: any;
  minDate: any;
  ScValue: any = "hmr";
  CustomerName: any;
  MakeName: any;
  ModelName: any;
  reqMakeId: number;
  reqmodelId: number;
  serviceContractcounterr: boolean = false;
  lastServiceRowWhileRenewal: boolean = false;
  lowestIndex: any;
  contractLevel: number = 1;
  reg = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{1,4})$/;
  @ViewChild("Newadd") Newadd: Popup;
  @ViewChild("updateConfirmation") updateConfirmation: Popup;
  @ViewChild("addConfirmations") addConfirmations: Popup;
  @ViewChild("updatepop") updatepop: Popup;
  @ViewChild("inputfilter") inputfilter: ElementRef;

  serviceValidation = 0;
  sst: any;
  ssterr: boolean = false;
  lastServiceStatus: boolean = false;
  preventiveId: any;
  NoOfServiceContractYear: any;
  selectedItem: any = "";
  inputChanged: any = "";
  serviceScheduleNumber = 1;
  ListOfPreventiveMaintenanceDetails = [];
  config2: any = {
    placeholder: "Serial Number",
    sourceField: ["serial_Number"],
  };
  orgId: number;
  userId: number;
  listServiceType = [];
  Listdescriptiondetails = [];
  alerttxt: any;
  Listbranchdetails = [];
  expanded: boolean = false;
  lat: number = 25.190519127063453;
  lng: number = 55.393190206959844;
  // lat:number=11.1271;
  // lng:number=78.6569;
  latitude: any;
  longitude: any;
  durationCount: number;
  secToMin = 0; //checking into mins
  secToHours = 0;
  secToHours_Remainder = 0;
  Hoursprice: number = 0;
  FinalDuration = 0;
  Price: number = 0;
  seconds = 0;
  locality: string;
  english = /^[A-Za-z]*$/;
  pdfSrc: string = "";
  travelhours = 0;
  minstravel = 0;
  Finalmins = 0;
  FileData: any;
  partsValidation = 0;
  zoomIn = 12;
  ListofSublocality = [];
  ListEmiratesdetails = [];
  emirates: any;
  subLocality: any;
  newEmirate_err: boolean = false;
  newsubLocality_err: boolean = false;
  renewalPMAC: boolean = false;
  optionsModel: number[];
  editcontractStatus: boolean = false;
  myOptions: IMultiSelectOption[];
  RenewalTravelCost: any;
  RenewalTravelHours: any;
  originalEndDate: any;
  public uploader: FileUploader = new FileUploader({
    url: "/api/upload",
    itemAlias: "photo",
  });
  constructor(
    public dialogService: DialogService,
    public _authservice: AuthPublicService,
    private toastyService: ToastyService,
    private toastyConfig: ToastyConfig,
    private httpClient: HttpClient,
    private http: Http,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    $("#myModal").modal("show");
    //this.getEmptyAllField();
    this.loading = true;
    if (
      this.route.params["value"].orgId === "" ||
      this.route.params["value"].orgId === undefined ||
      this.route.params["value"].orgId === null ||
      this.route.params["value"].userId === undefined ||
      this.route.params["value"].userId === "" ||
      this.route.params["value"].userId === null
    ) {
      window.location.href = "https://still.alshirawi.com/highmessaging/";
    } else {
      this.orgId = this.route.params["value"].orgId;
      this.userId = this.route.params["value"].userId;
      this._authservice.userId = this.userId;
      this._authservice.orgId = this.orgId;
      console.log("OrgId " + this.orgId);
      console.log("UserId " + this.userId);
    }
    // else if(this.route.params['value'].serialNumber == '' || this.route.params['value'].serialNumber == null || this.route.params['value'].serialNumber == undefined) {

    // }
    this.getbranchdetails();
    this.getTravelCostvalues();
    this.minDate = moment().format("YYYY-MM-DD");
    this.getAllMakedetails();
    this.getTechnicianName();
    this.getAllServiceDetails();
    this.getAllCustomerMasterDetails();
    this.getAllPreventiveMaintenanceDetails();
    this.getdescriptiondetails();
    this.getAllPmaCategorydetails();
    this.ListOfSecondFields.push({
      sst: "",
      hmr: "",
      date: "",
      serviceType: "",
      labour_Cost: "",
      labour_hour: "",
      spare_Cost: "",
      travel_Cost: "",
      travel_hour: "",
      consumables: "",
    });

    this.yeardropdown();
    this.serviceContractYearDropdown();
    this.noofservicecontractYearsdropdown();
    this.noofserviceRemainderdaysdropdown();
    this.getemiratesdetails();
    //this.getAllSublocalitydetails();
    if (this.route.params["value"].renewal == "yes") {
      this.renewalPMAC = true;
      this.lastServiceStatus = false;

      this.InputSerialNumber(this.route.params["value"].serialNumber);
    } else {
      this.loading = false;
      this.renewalPMAC = false;
      this.lastServiceStatus = true;
    }
  }

  handleFileInput(files: FileList, event) {
    this.fileToUpload = files.item(0);
    this.fileName = this.fileToUpload;
    this.downloaderr = false;

    this.FileShow = "";
    // if(this.pdfSrc==""||this.pdfSrc==null){
    //   this.FileShow="";
    // }else{
    //   this.FileShow=this.fileToUpload.name;
    // }
  }

  originalEndDateChange() {
    if (this.originalEndDate == "" || this.originalEndDate == undefined) {
      this.originalenddateerr = true;
    } else {
      this.originalenddateerr = false;
    }
  }

  getAllPmaCategorydetails() {
    //this.getlabourcostdetails();
    let makeObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getPmaCategorydetails", makeObj).subscribe(
      (res) => {
        let ResponePmaCategory = res.json();

        if (ResponePmaCategory.length > 0) {
          this.ListPmaCategoryDetails = ResponePmaCategory;
          let pusharr = [];
          for (let i = 0; i < this.ListPmaCategoryDetails.length; i++) {
            pusharr.push({
              value: this.ListPmaCategoryDetails[i]._id.toString(),
              label: this.ListPmaCategoryDetails[i].pmacategory.toUpperCase(),
            });
          }
          this.PmaCategoryDropdown = pusharr;

          console.log(this.ListPmaCategoryDetails);
        } else {
          this.loading = false;
        }
      },
      (err) => {
        this.loading = false;
        if (err.status != 200) {
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
      }
    );
  }

  getemiratesdetails() {
    let emiratesObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getEmiratesdetails", emiratesObj).subscribe(
      (res) => {
        let responseEmirates = res.json();
        this.ListEmiratesdetails = responseEmirates.result_data;
        if (this.ListEmiratesdetails.length > 0) {
          console.log("this.ListEmiratesdetails", this.ListEmiratesdetails);
          let pusharr = [];
          for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
            pusharr.push({
              value: this.ListEmiratesdetails[i]._id.toString(),
              label: this.ListEmiratesdetails[i].emirates.toUpperCase(),
            });
          }
          this.emiratesOptions = pusharr;
        } else {
        }
      },
      (err) => {
        if (err.status != 200) {
          this.alerttxt = "Unable to load the Emirates value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  getAllSublocalitydetails(value) {
    let Sublocality = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getSubLocalitydetails", Sublocality).subscribe(
      (res) => {
        this.ListofSublocality = [];
        let Response = res.json();
        this.ListofSublocality = Response.result_data;
        if (this.ListofSublocality.length > 0) {
          //console.log("this.ListEmiratesdetails",this.ListEmiratesdetails);
          let pusharr = [];
          for (let i = 0; i < this.ListofSublocality.length; i++) {
            if (this.ListofSublocality[i].emirateid == parseInt(value)) {
              pusharr.push({
                value: this.ListofSublocality[i]._id.toString(),
                label: this.ListofSublocality[i].sublocation.toUpperCase(),
              });
            }
          }
          this.subLocalityOptions = pusharr;
          this.loading = false;
        } else {
          this.loading = false;
        }
      },
      (err) => {
        if (err.status != 200) {
          this.loading = false;
          this.alerttxt = "Unable to load the Sublocality value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  getsubLocalitydetails(value) {
    if (value == "" || value == undefined) {
      this.newsubLocality_err = true;
    } else if (
      this.emirates == "" ||
      this.emirates == null ||
      this.emirates == undefined
    ) {
      this.subLocality = "";
    } else {
      this.newsubLocality_err = false;
      this.expanded = true;
      for (let i = 0; i < this.ListofSublocality.length; i++) {
        if (this.ListofSublocality[i]._id == parseInt(value)) {
          this.lat = parseFloat(this.ListofSublocality[i].latitude);
          this.lng = parseFloat(this.ListofSublocality[i].longitude);
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          this.zoomIn = 14;
        }
      }
    }
  }

  getEmiratedetails(value) {
    this.newEmirate_err = false;
    let pusharr = [];
    this.subLocality = [];
    this.subLocalityOptions = [];
    for (let i = 0; i < this.ListEmiratesdetails.length; i++) {
      if (this.ListEmiratesdetails[i]._id == value) {
        this.lat = parseFloat(this.ListEmiratesdetails[i].latitude);
        this.lng = parseFloat(this.ListEmiratesdetails[i].longitude);
      }
    }

    this.getAllSublocalitydetails(value);
    // for(let i=0;i<this.ListofSublocality.length;i++){
    //   if(this.ListofSublocality[i].emirateid==parseInt(value)){
    //      pusharr.push({'value':this.ListofSublocality[i]._id.toString(),'label':this.ListofSublocality[i].sublocation.toUpperCase()})

    //   }
    // }
    // this.subLocalityOptions=pusharr;
  }

  clear() {
    this.fileToUpload = null;
    this.fileName = null;
    this.pdfSrc = "";
    this.downloaderr = false;
    this.inputfilter.nativeElement.value = "";
  }

  download() {
    console.log(this.fileName);
    if (this.fileName == null) {
      // alert("The file cannot be empty");
      this.downloaderr = true;
    } else {
      this.downloaderr = false;

      saveAs(this.fileName);
    }
  }

  Makepushfordropdown() {
    let pusharr = [];
    //pusharr.push({'value':"Add New Make",'label':"Add New Make"})
    for (let i = 0; i < this.ListMakeDetails.length; i++) {
      pusharr.push({
        value: this.ListMakeDetails[i]._id.toString(),
        label: this.ListMakeDetails[i].make.toUpperCase(),
      });
    }
    this.Makedropdown = pusharr;
  }

  ModelDropdownpush() {
    let pusharr = [];
    for (let i = 0; i < this.ListModelDetails.length; i++) {
      pusharr.push({
        value: this.ListModelDetails[i]._id.toString(),
        label: this.ListModelDetails[i].model.toUpperCase(),
      });
    }
    this.Modeldropdown = pusharr;
  }

  ServicetypeOption() {
    let pusharray = [];
    pusharray.push({ value: "New Vehicle", label: "New Vehicle" });
    for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
      pusharray.push({
        value: this.ListOfCheckListMaster[i]._id.toString(),
        label: this.ListOfCheckListMaster[i].servicetype.toUpperCase(),
      });
    }
    this.lastservicetypeOption = pusharray;
    this.ScheduleservicetypeOption = pusharray;
  }
  yeardropdown() {
    let pusharr = [];
    const currentYear = new Date().getFullYear();
    for (let i = 2000; i <= currentYear; i++) {
      pusharr.push({ value: i.toString(), label: i.toString() });
    }
    this.yearOptions = pusharr;
  }
  serviceContractYearDropdown() {
    let pusharr = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      pusharr.push({ value: i.toString(), label: i.toString() });
    }
    this.serviceContractYearOptions = pusharr;
  }
  noofservicecontractYearsdropdown() {
    let pusharr1 = [];
    for (let i = 1; i <= 5; i++) {
      pusharr1.push({ value: i.toString(), label: i.toString() });
    }
    this.noofservicecontractYears = pusharr1;
  }
  noofserviceRemainderdaysdropdown() {
    let pusharr2 = [];
    for (let i = 1; i <= 7; i++) {
      pusharr2.push({ value: i.toString(), label: i.toString() });
    }
    this.noofserviceRemainderdays = pusharr2;
  }

  TechnicianDetailsload() {
    let technicianArr = [];
    for (var i = 0; i < this.ListTechnicianName.length; i++) {
      let obj = {
        label:
          this.ListTechnicianName[i].FIRST_NAME +
          " " +
          this.ListTechnicianName[i].LAST_NAME,
        value: this.ListTechnicianName[i].ID,
      };
      technicianArr.push(obj);
    }
    this.techinicianDetails = technicianArr;
  }

  toggle() {
    this.getbranchdetails();
    console.log("Listbranchdetails after toggle", this.Listbranchdetails);
    this.expanded = !this.expanded;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  findlocation(event) {
    this.zoomIn = 12;
    let addressobj = {
      address: event.target.value,
    };
    return this.http
      .post(
        "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
        addressobj
      )
      .subscribe(
        (res) => {
          let Response = res.json();
          if (Response.results.length > 0) {
            this.lat = Response.results[0].geometry.location.lat;
            this.lng = Response.results[0].geometry.location.lng;
          } else {
            alert("please enter valid Area Name");
          }
        },
        (err) => {}
      );
  }

  mapClicked(Event) {
    this.latitude = Event.coords.lat;
    this.longitude = Event.coords.lng;
    this.durationCount = 0;
    this.travelhours = 0;
    this.minstravel = 0;
    this.Finalmins = 0;
    let originArr = [];
    let distinationArr = [];
    let distanceArr = [];
    this.branch = "";

    let addressobj = {
      lat_and_lang: Event.coords.lat + "," + Event.coords.lng,
    };
    return this.http
      .post(
        "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
        addressobj
      )
      .subscribe((res) => {
        let response = res.json();
        console.log("first Google API " + res.json());
        console.log("first Google API String" + JSON.stringify(res.json()));
        console.log(
          "Listbranchdetails after mapclicked",
          this.Listbranchdetails
        );
        this.mclocation = response.results[0].formatted_address;
        this.locality = response.results[0].formatted_address;
        for (
          let m = 0;
          m < response.results[0].address_components.length;
          m++
        ) {
          for (
            let t = 0;
            t < response.results[0].address_components[m].types.length;
            t++
          ) {
            if (
              response.results[0].address_components[m].types[t] ==
                "sublocality" ||
              response.results[0].address_components[m].types[t] ==
                "sublocality_level_1" ||
              response.results[0].address_components[m].types[t] == "locality"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            } else if (
              response.results[0].address_components[m].types[t] ==
              "administrative_area_level_1"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            } else if (
              response.results[0].address_components[m].types[t] ==
              "administrative_area_level_2"
            ) {
              this.locality =
                response.results[0].address_components[m].short_name;
              break;
            }
          }
        }
        console.log(
          "Listbranchdetails in mapclicked after forloop",
          this.Listbranchdetails
        );
        if (this.english.test(this.locality) == false) {
          this.locality = this.mclocation;
        } else {
          // alert('its English' + this.locality)
        }
        if (
          this.mclocation == "" ||
          this.mclocation == undefined ||
          this.mclocation == null
        ) {
          this.mcLocationerr = true;
        } else {
          this.mcLocationerr = false;
        }
        let loglatArr = [];
        for (let i = 0; i < this.Listbranchdetails.length; i++) {
          loglatArr.push(
            this.Listbranchdetails[i].latitude +
              "," +
              this.Listbranchdetails[i].longitude
          );
        }

        // let urlReq = "https://maps.googleapis.com/maps/api" + "/distancematrix/json?units=imperial&origins="+Event.coords.lat+","+Event.coords.lng+"&destinations="+loglatArr.join('|').toString()+"&key=AIzaSyA5qcFi5QycVzjof_zufO8MX8HoSwpGc5o";

        let distinationobj = {
          lat_and_lang: Event.coords.lat + "," + Event.coords.lng,
          destinations: loglatArr.join("|").toString(),
        };
        return this.http
          .post(
            "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
            distinationobj
          )
          .subscribe(
            (res) => {
              console.log("Second Google API" + res.json());
              console.log(
                "Second Google API String" + JSON.stringify(res.json())
              );
              let distanceResponse = res.json();
              let I_index = 0;
              let smallest =
                distanceResponse.rows[0].elements[0].duration.value;

              for (
                let i = 0;
                i < distanceResponse.rows[0].elements.length;
                i++
              ) {
                if (distanceResponse.rows[0].elements[i].status == "OK") {
                  if (
                    distanceResponse.rows[0].elements[i].duration.value <
                    smallest
                  ) {
                    smallest =
                      distanceResponse.rows[0].elements[i].duration.value;
                    I_index = i;
                  }
                }
              }

              this.branch = this.Listbranchdetails[I_index].branchAlias;
              this.BranchPlaceholder = this.branch;
              for (let i = 0; i < this.Listbranchdetails.length; i++) {
                if (this.branch == this.Listbranchdetails[i].branchAlias) {
                  this.branch = this.Listbranchdetails[i]._id.toString();
                }
              }
              console.log("branch", this.branch);

              console.log("Final Smallest Seconds " + smallest);
              //smallest = 6589;
              this.seconds = smallest;
              console.log("durationValue " + this.seconds);
              this.secToMin = Math.floor(this.seconds / 60); //checking into mins
              this.secToHours = 0;
              this.secToHours_Remainder = 0;
              this.Hoursprice = 0;
              this.FinalDuration = 0;
              this.Price = 0;
              this.travelhours = 0;
              this.Finalmins = 0;
              this.minstravel = 0;
              if (this.secToMin >= 60) {
                this.secToHours = Math.floor(this.seconds / 3600);
                this.travelhours = this.secToHours;
                // this.Hoursprice = this.secToHours*165;
                this.Hoursprice = this.TravelcostValue * this.secToHours;
                this.secToHours_Remainder = this.seconds % 3600;
                if (this.secToHours_Remainder <= 1800) {
                  this.Price = this.Hoursprice + this.TravelcostValue / 2;
                  this.minstravel = 0.5;
                } else if (
                  this.secToHours_Remainder > 1800 &&
                  this.secToHours_Remainder <= 2700
                ) {
                  this.Price = this.Hoursprice + (this.TravelcostValue * 3) / 4;
                  this.minstravel = 0.75;
                } else if (
                  this.secToHours_Remainder > 2700 &&
                  this.secToHours_Remainder < 3600
                ) {
                  // this.Price=this.Hoursprice+165;
                  this.Price = this.Hoursprice + this.TravelcostValue;
                  this.travelhours = this.travelhours + 1;
                }
              } else {
                if (this.secToMin <= 30) {
                  this.FinalDuration = 30;
                  this.minstravel = 0.5;
                } else if (this.secToMin > 30 && this.secToMin <= 45) {
                  this.FinalDuration = 45;
                  this.minstravel = 0.75;
                } else if (this.secToMin > 45) {
                  this.FinalDuration = 60;
                  this.travelhours = this.travelhours + 1;
                }
              }

              if (this.FinalDuration == 30) {
                this.Price = this.TravelcostValue / 2;
              } else if (this.FinalDuration == 45) {
                this.Price = (this.TravelcostValue * 3) / 4;
              } else if (this.FinalDuration == 60) {
                this.Price = this.TravelcostValue;
              }

              this.Finalmins = this.travelhours + this.minstravel;
              for (
                let sr = this.serviceScheduleNumber - 1;
                sr < this.ListOfSecondFields.length;
                sr++
              ) {
                this.ListOfSecondFields[sr].travel_Cost = (
                  this.Price * 2
                ).toFixed(2);

                this.ListOfSecondFields[sr].travel_hour = this.Finalmins * 2;
              }
            },
            (err) => {
              alert(err);
            }
          );
      });
  }

  getTravelCostvalues() {
    let obj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getTravelCost", obj).subscribe(
      (res) => {
        this.TravelCostValuearr = res.json();
        if (this.TravelCostValuearr.length > 0) {
          console.log("TravelCostValuearr", this.TravelCostValuearr);
          this.TravelcostValue = parseInt(
            this.TravelCostValuearr[0].TravelCost
          );
          console.log("TravelCostValue", this.TravelcostValue);
        } else {
          alert("Please add Travel Cost");
          this.router.navigate([
            "node/travelcost",
            { orgId: this.orgId, userId: this.userId },
          ]);
        }
      },
      (err) => {
        console.log(err);
      }
    );
  }
  getbranchdetails() {
    this.loading = true;
    let branchObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getbranchdetails", branchObj).subscribe(
      (res) => {
        let responseBranch = res.json();
        this.Listbranchdetails = responseBranch;
        let pusharray = [];
        for (let b = 0; b < this.Listbranchdetails.length; b++) {
          pusharray.push({
            value: this.Listbranchdetails[b]._id.toString(),
            label: this.Listbranchdetails[b].branchAlias,
          });
        }
        this.BranchDropDown = pusharray;
        console.log("Listbranchdetails", this.Listbranchdetails);
        if (this.latlong.length == 0) {
          for (let i = 0; i < this.Listbranchdetails.length; i++) {
            let obj = {
              latitude: parseFloat(this.Listbranchdetails[i].latitude),
              longitude: parseFloat(this.Listbranchdetails[i].longitude),
            };
            this.latlong.push(obj);
          }
          console.log("latlong", this.latlong);
        }
        this.loading = false;
        //console.log(responseBranch);
      },
      (err) => {
        this.loading = false;
        if (err.status != 200) {
          this.alerttxt = "Unable to load the branch value";
          this.getWarningFunction(this.alerttxt);
        }
      }
    );
  }

  getdescriptiondetails() {
    this.loading = true;
    let descriptionObj = {
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getdescriptiondetails", descriptionObj)
      .subscribe(
        (res) => {
          let responseDescription = res.json();
          this.Listdescriptiondetails = responseDescription;
          this.loading = false;
          console.log();
        },
        (err) => {
          this.loading = false;

          if (err.status != 200) {
            console.log("hello");
            this.alerttxt = "Unable to load the branch value";
            this.getWarningFunction(this.alerttxt);
          }
        }
      );
  }

  getAllServiceDetails() {
    this.loading = true;
    let ServiceObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getServiceTypedetails", ServiceObj).subscribe(
      (res) => {
        this.loading = false;
        let ServiceResponse = res.json();
        this.ListOfCheckListMaster = res.json();
        this.ServicetypeOption();

        for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
          let serviceObj = {
            service: this.ListOfCheckListMaster[i].servicetype,
            check: false,
          };
          this.listServiceType.push(serviceObj);
        }
        this.ListOfFields.push({
          part_Number: "",
          descriptions: "",
          quantity: "",
          unit_Price: "",
          total: "",
          discount: "",
          selling_Price: "",
          service_Type: this.listServiceType,
          cost_Type: "",
        });
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  SchChange() {
    this.lastServiceType = "";
  }

  editdeatils() {
    this.getEmptyAllField();
    this.renewalPMAC = false;
    this.editcontractStatus = true;
    this.lastServiceStatus = false;

    this.getAllCustomerMasterDetails();
    this.getAllPreventiveMaintenanceDetails();
  }

  backtoContractCreating() {
    this.lastServiceStatus = true;
    this.renewalPMAC = false;
    this.editcontractStatus = false;
    this.getEmptyAllField();
    this.getAllCustomerMasterDetails();
    this.yeardropdown(); //
    this.noofservicecontractYearsdropdown(); //
    this.noofserviceRemainderdaysdropdown(); //
    //this.getAllServiceDetails();//
    this.getAllMakedetails(); //
    this.router.navigate([
      "node/preventiveMaintenance",
      {
        orgId: this.route.params["value"].orgId,
        userId: this.route.params["value"].userId,
      },
    ]);

    //this.getAllPreventiveMaintenanceDetails();
  }

  getmodalValueBasedOnMakeId() {
    let reqModelObj = {
      MakeId: this.make,
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getModeldetailsBasedOnMakeID", reqModelObj)
      .subscribe(
        (res) => {
          let ResponeModel = res.json();
          this.ListModelDetails = res.json();
          //this.loadPartdetails();
          this.ModelDropdownpush();
        },
        (err) => {
          this.ModelDropdownpush();
          this.loading = false;
          if (err.status != 200) {
            this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
          }
        }
      );
  }

  onInputChangedEvent(val: string) {
    this.inputChanged = val;
    this.InputSerialNumber(this.inputChanged);
  }

  onSelect(val: string) {
    this.selectedItem = val;
    this.InputSerialNumber(this.selectedItem);
  }

  getAllPreventiveMaintenanceDetails() {
    this.loading = true;

    let reqPMSObj = {
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getAllPreventiveMaintenanceDetails", reqPMSObj)
      .subscribe(
        (res) => {
          this.loading = false;
          let CustomerArr = [];
          this.ListOfPreventiveMaintenanceDetails = res.json();
          let pusharr = [];
          for (
            let i = 0;
            i < this.ListOfPreventiveMaintenanceDetails.length;
            i++
          ) {
            pusharr.push(
              this.ListOfPreventiveMaintenanceDetails[i].serial_Number
            );
          }
          let UniqueSerialNumber = pusharr.filter(function (item, i, ar) {
            return ar.indexOf(item) === i;
          });
          let FinalUniqueSerialNumber = [];
          for (let su = 0; su < UniqueSerialNumber.length; su++) {
            let obj = {
              label: UniqueSerialNumber[su],
              value: UniqueSerialNumber[su],
            };
            FinalUniqueSerialNumber.push(obj);
          }
          this.SerialNumberDropdown = FinalUniqueSerialNumber;
        },
        (err) => {
          this.loading = false;
        }
      );
  }

  getmakedetails() {
    this.loading = true;
    let makeObj = {
      makeId: this.reqMakeId,
      orgId: this.orgId,
    };
    return this.http.post("/api/getMakedetailsBasedOnId", makeObj).subscribe(
      (res) => {
        this.loading = false;
        let response = res.json();
        if (response.length > 0) {
          this.make = response[0].make.toUpperCase();
        }
      },
      (err) => {
        this.loading = false;
        this.msgtext = "Unable to load Make";
        this.getWarningFunction(this.msgtext);
      }
    );
  }
  getmodeldetails() {
    this.loading = true;
    let modelObj = {
      modelId: this.reqmodelId,
      orgId: this.orgId,
    };
    return this.http.post("/api/getModeldetailsBasedOnId", modelObj).subscribe(
      (res) => {
        this.loading = false;
        let response = res.json();
        if (response.length > 0) {
          this.model = response[0].model.toUpperCase();
        }
      },
      (err) => {
        this.loading = false;
        this.msgtext = "Unable to load Model";
        this.getWarningFunction(this.msgtext);
      }
    );
  }

  serviceStatusChecking_serviceForm(PMA_ID, SerialNumber, noOfService) {
    let statusObj = {
      pmId: PMA_ID,
      serialNumber: SerialNumber,
    };
    return this.http
      .post("/api/serviceStatusChecking_serviceFormAPI", statusObj)
      .subscribe((res) => {
        let response = res.json();
        if (
          response[response.length - 1].service_Scheduler_Number ==
            noOfService &&
          response[response.length - 1].status == 1
        ) {
          this.lastServiceRowWhileRenewal = true;
        } else {
          this.lastServiceRowWhileRenewal = false;
        }
      });
  }

  InputSerialNumber(getValue) {
    if (getValue == "" || getValue == undefined || getValue == null) {
      this.serialnumber = "";
      this.getEmptyAllField();
      this.loading = false;
    } else {
      this.serialnumber = getValue;
      // if(this.lastServiceStatus == true) {
      //   this.serialnumber = getValue.serial_Number;
      // } else {
      //   this.serialnumber = getValue;
      // }

      this.serialNumbercounterr = false;
      let serialObj = {
        serialNumber: this.serialnumber,
        orgId: this.orgId,
      };
      return this.http
        .post("/api/CheckSerialNumberExistOrNot", serialObj)
        .subscribe(
          (res) => {
            let SerialResponse = res.json();
            this.getListClientdetails = SerialResponse;
            console.log(this.getListClientdetails);
            if (SerialResponse.length > 0) {
              let SerialNumberCount = SerialResponse.length - 1;
              this.serviceScheduleNumber =
                this.getListClientdetails[SerialNumberCount].serviceScheduleDay;

              this.clientName =
                this.getListClientdetails[
                  SerialNumberCount
                ].client_Name.toString();

              for (let i = 0; i < this.ListOfCustomermaster.length; i++) {
                if (
                  this.ListOfCustomermaster[i]._id == parseInt(this.clientName)
                ) {
                  this.ClientNamePlaceholder =
                    this.ListOfCustomermaster[i].customer_Name;
                  this.CustomerName =
                    this.ListOfCustomermaster[i].customer_Name;
                }
              }
              this.preventiveId =
                this.getListClientdetails[SerialNumberCount]._id;

              // this.clientName = this.CustomerName;
              //this.serialnumber = this.getListClientdetails[SerialNumberCount].serial_Number;
              this.mclocation =
                this.getListClientdetails[SerialNumberCount].mcLocation;
              this.clientPhonenumber =
                this.getListClientdetails[SerialNumberCount].phone_Number;
              this.email = this.getListClientdetails[SerialNumberCount].email;

              this.make =
                this.getListClientdetails[SerialNumberCount].make.toString();
              for (let i = 0; i < this.ListMakeDetails.length; i++) {
                if (this.make == this.ListMakeDetails[i]._id) {
                  this.MakePlaceholder = this.ListMakeDetails[i].make;
                  this.MakeName = this.ListMakeDetails[i].make.toUpperCase();
                }
              }
              this.Makepushfordropdown();
              this.model =
                this.getListClientdetails[SerialNumberCount].model.toString();
              this.getmodalValueBasedOnMakeId();
              for (let i = 0; i < this.ListModelDetails.length; i++) {
                if (this.model == this.ListModelDetails[i]._id) {
                  this.ModelPlaceholder =
                    this.ListModelDetails[i].model.toUpperCase();
                  this.ModelName = this.ListModelDetails[i].model.toUpperCase();
                }
              }
              this.getmodeldetails();
              this.PmaCategory =
                this.getListClientdetails[SerialNumberCount].pmacategory;
              this.ListPmaCategoryDetails.forEach((element) => {
                if (element._id == this.PmaCategory) {
                  this.PmaCategoryplaceholder = element.pmacategory;
                }
              });

              if (this.route.params["value"].renewal == "yes") {
                this.contractLevel =
                  this.getListClientdetails[SerialNumberCount].contractLevel +
                  1;
                console.log("contractLevel ", this.contractLevel);
                this.SYdisabled = false;
              } else {
                this.contractLevel =
                  this.getListClientdetails[SerialNumberCount].contractLevel;
              }
              this.hmrHours = this.getListClientdetails[SerialNumberCount].hmr;
              this.technicianName =
                this.getListClientdetails[SerialNumberCount].technician_Name;
              for (let i = 0; i < this.ListTechnicianName.length; i++) {
                if (this.technicianName == this.ListTechnicianName[i].ID) {
                  this.TechnicianNamePlaceholder =
                    this.ListTechnicianName[i].FIRST_NAME +
                    " " +
                    this.ListTechnicianName[i].LAST_NAME;
                }
              }
              // this.TechnicianNamePlaceholder=this.getListClientdetails[SerialNumberCount].technician_Name;
              this.TechnicianDetailsload();

              this.ServicetypeOption();

              this.yearofmanufacturer =
                this.getListClientdetails[
                  SerialNumberCount
                ].year_Of_manufacturer.toString();
              this.YearofManufacturePlaceholder =
                this.getListClientdetails[
                  SerialNumberCount
                ].year_Of_manufacturer.toString();
              this.yeardropdown();
              this.branch =
                this.getListClientdetails[SerialNumberCount].branch.toString();
              this.Listbranchdetails.forEach((branchname) => {
                if (this.branch == branchname._id) {
                  this.BranchPlaceholder = branchname.branch;
                }
              });
              // this.BranchPlaceholder=this.branch;
              this.serviceContractOffered =
                this.getListClientdetails[
                  SerialNumberCount
                ].service_Contract_Offered.toString();
              this.ServiceContracttplaceholder =
                this.getListClientdetails[
                  SerialNumberCount
                ].service_Contract_Offered;
              this.yeardropdown();
              this.contractReference =
                this.getListClientdetails[SerialNumberCount].contract_Reference;

              this.sst = this.getListClientdetails[SerialNumberCount].sst;
              this.sst = this.getListClientdetails[SerialNumberCount].sst;
              for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
                if (this.sst == this.ListOfCheckListMaster[i]._id) {
                  this.ScheduleServiceTypePlaceholder =
                    this.ListOfCheckListMaster[i].servicetype;
                }
              }
              this.pdfSrc =
                this.getListClientdetails[SerialNumberCount].fileName;
              // this.fileName=this.pdfSrc;
              console.log("pdfSrc", this.pdfSrc);
              if (this.pdfSrc == "" || this.pdfSrc == null) {
                this.FileShow = "";
              } else {
                this.FileShow = this.pdfSrc;
              }
              this.emirates =
                this.getListClientdetails[
                  SerialNumberCount
                ].emiratesId.toString();
              for (let i = 0; i < this.emiratesOptions.length; i++) {
                if (this.emirates == this.emiratesOptions[i].value) {
                  this.emiratesedit = this.emiratesOptions[i].label;
                }
              }
              this.getAllSublocalitydetails(this.emirates);
              this.subLocality =
                this.getListClientdetails[
                  SerialNumberCount
                ].subLocalityId.toString();
              for (let i = 0; i < this.subLocalityOptions.length; i++) {
                if (this.subLocality == this.subLocalityOptions[i].value) {
                  this.subLocalityedit = this.subLocalityOptions[i].label;
                }
              }
              if (
                this.editcontractStatus == true &&
                this.serviceScheduleNumber == 1
              ) {
                this.SYdisabled = false;
              } else {
              }

              this.ListOfFields =
                this.getListClientdetails[SerialNumberCount].Sparedetails;
              if (this.route.params["value"].renewal == "yes") {
                this.serviceScheduleNumber = 1;
                // this.contractLevel = this.getListClientdetails[0].contractLevel + 1;
                this.RenewalTravelCost =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].Servicedetails[0].travel_Cost;
                this.RenewalTravelHours =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].Servicedetails[0].travel_hour;
                this.lastServiceType =
                  this.getListClientdetails[SerialNumberCount].Servicedetails[
                    this.getListClientdetails[SerialNumberCount].Servicedetails
                      .length - 1
                  ].service_Type;
                if (this.lastServiceType == "New Vehicle") {
                  this.LastServiceTypePlaceholder = "New Vehicle";
                } else {
                  for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
                    if (
                      this.lastServiceType == this.ListOfCheckListMaster[i]._id
                    ) {
                      this.LastServiceTypePlaceholder =
                        this.ListOfCheckListMaster[i].servicetype;
                    }
                  }
                }
                this.lastServiceHour =
                  this.getListClientdetails[SerialNumberCount].Servicedetails[
                    this.getListClientdetails[SerialNumberCount].Servicedetails
                      .length - 1
                  ].hmr;
              } else {
                this.originalEndDate =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].original_end_date;
                this.lastServiceType =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].last_Service_Type;
                if (this.lastServiceType == "New Vehicle") {
                  this.LastServiceTypePlaceholder = "New Vehicle";
                } else {
                  for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
                    if (
                      this.lastServiceType == this.ListOfCheckListMaster[i]._id
                    ) {
                      this.LastServiceTypePlaceholder =
                        this.ListOfCheckListMaster[i].servicetype;
                    }
                  }
                }
                this.lastServiceHour =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].last_Service_Hours;
                this.noofService =
                  this.getListClientdetails[SerialNumberCount].no_Of_Service;
                this.startdate =
                  this.getListClientdetails[SerialNumberCount].start_Date;
                this.endDate =
                  this.getListClientdetails[SerialNumberCount].end_Date;
                this.noofServiceContractYear =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].noofServiceContractYear.toString();
                this.ServiceContractyearsPlaceholder =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].noofServiceContractYear;
                this.noofservicecontractYearsdropdown();
                this.serviceRemainderDays =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].remainderday.toString();
                this.ServiceRemainderPlaceholder =
                  this.getListClientdetails[SerialNumberCount].remainderday;
                this.noofserviceRemainderdaysdropdown();
                this.interval =
                  this.getListClientdetails[SerialNumberCount].serviceInterval;
                this.intervalofservice =
                  this.getListClientdetails[
                    SerialNumberCount
                  ].days_Interval_Of_Service;
                this.ListOfSecondFields =
                  this.getListClientdetails[SerialNumberCount].Servicedetails;
                this.serviceStatusChecking_serviceForm(
                  this.preventiveId,
                  this.serialnumber,
                  this.noofService
                );
              }
              this.loading = false;
              // this.inputfilter.nativeElement.innerHTML=this.pdfSrc;
            } else {
              this.loading = false;
              this.getEmptyAllField();
              //this.serialnumber = getValue.trim();
            }
            // if(this.route.params['value'].renewal == 'yes'){
            //   this.contractLevel = this.getListClientdetails[0].contractLevel + 1;
            // }
            // else if(this.serviceScheduleNumber >1) {
            //   // alert('this Serial Number data Cannot update due to serivce Updated');
            //   // this.getEmptyAllField();
            // } else {
            //     this.contractLevel = this.getListClientdetails[0].contractLevel;

            // }
          },
          (err) => {
            // this.loading=false;
            this.loading = false;
            this.getEmptyAllField();
            this.msgtext = "Unable to load Serial Number details";
            this.getWarningFunction(this.msgtext);
          }
        );
    }
  }

  getTechnicianName() {
    let techObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getTechniciansName", techObj).subscribe(
      (res) => {
        res.json();
        this.ListTechnicianName = res.json().technicianResponse;
        this.TechnicianDetailsload();
      },
      (err) => {
        this.loading = false;
      }
    );
  }

  Inputbranch(value) {
    if (value == null || value == undefined || value == "") {
      this.brancherr = true;
    } else {
      this.brancherr = false;
    }
    if (
      this.mclocation == "" ||
      this.mclocation == null ||
      this.mclocation == undefined
    ) {
      this.branch = "";
      this.BranchPlaceholder = "CHOOSE THE BRANCH";
      $("#branchlocation").val("");
      alert("please choose the Machine location first");
    } else {
      let loglatArr = [];
      for (let i = 0; i < this.Listbranchdetails.length; i++) {
        if (this.Listbranchdetails[i]._id == value) {
          this.Listbranchdetails[i].latitude;
          this.Listbranchdetails[i].longitude;
          loglatArr.push(
            this.Listbranchdetails[i].latitude +
              "," +
              this.Listbranchdetails[i].longitude
          );
        }
      }

      let locationobj = {
        address: this.mclocation,
      };
      if (
        this.latitude == "" ||
        this.latitude == undefined ||
        this.latitude == null ||
        this.longitude == "" ||
        this.longitude == undefined ||
        this.longitude == null
      ) {
        return this.http
          .post(
            "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
            locationobj
          )
          .subscribe(
            (res) => {
              let Response = res.json();
              if (Response.results.length > 0) {
                this.latitude = Response.results[0].geometry.location.lat;
                this.longitude = Response.results[0].geometry.location.lng;
              } else {
                //alert('please enter valid Area Name');
              }
            },
            (err) => {
              console.log(err);
            }
          );
      } else {
      }

      let distinationobj = {
        lat_and_lang: this.latitude + "," + this.longitude,
        destinations: loglatArr.join("|").toString(),
      };
      return this.http
        .post(
          "https://still.alshirawi.com/highmessaging/getAllGoogleMapsWebserviceDetails",
          distinationobj
        )
        .subscribe((res) => {
          // return this.http.get("https://maps.googleapis.com/maps/api/distancematrix/json?units=imperial&origins="+this.latitude+","+this.longitude+"&destinations="+loglatArr.join('|').toString()+"&key=AIzaSyA5qcFi5QycVzjof_zufO8MX8HoSwpGc5o").subscribe(res=>{

          let response = res.json();
          this.seconds = response.rows[0].elements[0].duration.value;
          console.log("durationValue " + this.seconds);
          this.secToMin = Math.floor(this.seconds / 60); //checking into mins
          this.secToHours = 0;
          this.secToHours_Remainder = 0;
          this.Hoursprice = 0;
          this.FinalDuration = 0;
          this.Price = 0;
          this.travelhours = 0;
          this.Finalmins = 0;
          this.minstravel = 0;
          if (this.secToMin >= 60) {
            this.secToHours = Math.floor(this.seconds / 3600);
            this.travelhours = this.secToHours;
            // this.Hoursprice = this.secToHours*165;
            this.Hoursprice = this.TravelcostValue * this.secToHours;
            this.secToHours_Remainder = this.seconds % 3600;
            if (this.secToHours_Remainder <= 1800) {
              this.Price = this.Hoursprice + this.TravelcostValue / 2;
              this.minstravel = 0.5;
            } else if (
              this.secToHours_Remainder > 1800 &&
              this.secToHours_Remainder <= 2700
            ) {
              this.Price = this.Hoursprice + (this.TravelcostValue * 3) / 4;
              this.minstravel = 0.75;
            } else if (
              this.secToHours_Remainder > 2700 &&
              this.secToHours_Remainder < 3600
            ) {
              // this.Price=this.Hoursprice+165;
              this.Price = this.Hoursprice + this.TravelcostValue;
              this.travelhours = this.travelhours + 1;
            }
          } else {
            if (this.secToMin <= 30) {
              this.FinalDuration = 30;
              this.minstravel = 0.5;
            } else if (this.secToMin > 30 && this.secToMin <= 45) {
              this.FinalDuration = 45;
              this.minstravel = 0.75;
            } else if (this.secToMin > 45) {
              this.FinalDuration = 60;
              this.travelhours = this.travelhours + 1;
            }
          }

          if (this.FinalDuration == 30) {
            this.Price = this.TravelcostValue / 2;
          } else if (this.FinalDuration == 45) {
            this.Price = (this.TravelcostValue * 3) / 4;
          } else if (this.FinalDuration == 60) {
            this.Price = this.TravelcostValue;
          }

          this.Finalmins = this.travelhours + this.minstravel;
          for (
            let sr = this.serviceScheduleNumber - 1;
            sr < this.ListOfSecondFields.length;
            sr++
          ) {
            this.ListOfSecondFields[sr].travel_Cost = (this.Price * 2).toFixed(
              2
            );

            this.ListOfSecondFields[sr].travel_hour = this.Finalmins * 2;
          }
        });
    }
  }

  getAllCustomerMasterDetails() {
    this.loading = true;
    let CustomerObj = {
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getCustomerMasterDetails", CustomerObj)
      .subscribe(
        (res) => {
          this.loading = false;
          let clientArr = [];
          this.ListOfCustomermaster = res.json();
          let pusharr = [];
          for (let i = 0; i < this.ListOfCustomermaster.length; i++) {
            pusharr.push({
              value: this.ListOfCustomermaster[i]._id.toString(),
              label: this.ListOfCustomermaster[i].customer_Name.toUpperCase(),
            });
          }
          this.ListofCustomermasterdropdown = pusharr;
        },
        (err) => {
          this.loading = false;
          if (err.status != 200) {
            this.msgtext = "Unable to load the Value";
            this.getWarningFunction(this.msgtext);
          }
        }
      );
  }

  getCustomerdetails(getName) {
    for (let i = 0; i < this.ListOfCustomermaster.length; i++) {
      if (this.ListOfCustomermaster[i]._id == parseInt(this.clientName)) {
        this.CustomerName = this.ListOfCustomermaster[i].customer_Name;
      }
    }
    this.chooseClientname = getName;
    this.clientPhonenumber = "";
    this.email = "";
    if (getName == "" || getName == undefined) {
      this.clienterr = true;
    } else {
      this.clienterr = false;

      for (var i = 0; i < this.ListOfCustomermaster.length; i++) {
        if (this.ListOfCustomermaster[i]._id == getName) {
          this.clientPhonenumber = this.ListOfCustomermaster[i].landline_Number;
          this.email = this.ListOfCustomermaster[i].email;
          this.clientName = getName;
        }
      }
    }
  }

  getAllMakedetails() {
    this.loading = true;
    let MakeObj = {
      orgId: this.orgId,
    };
    return this.http.post("/api/getMakedetails", MakeObj).subscribe(
      (res) => {
        this.loading = false;
        let ResponeMake = res.json();
        this.ListMakeDetails = res.json();
        this.Makepushfordropdown();
      },
      (err) => {
        this.loading = false;
        if (err.status != 200) {
          this.msgtext = "Unable to load the Value";
          this.getWarningFunction(this.msgtext);
        }
      }
    );
  }

  getMakedetails(makevalue) {
    for (var i = 0; i < this.ListMakeDetails.length; i++) {
      if (this.ListMakeDetails[i]._id == this.make) {
        this.MakeName = this.ListMakeDetails[i].make.toUpperCase();
      }
    }
    this.newMake_err = false;
    this.model = "";
    //this.loadPartdetails();
    this.makeerr = false;
    this.ListModelDetails = [];
    this.getmodalValueBasedOnMakeId();
  }

  getModeldetails(modelValue) {
    if (this.make == "" || this.make == undefined || this.make == null) {
      alert("please select first Make");
      this.model = "";
    } else {
      for (var i = 0; i < this.ListModelDetails.length; i++) {
        if (this.ListModelDetails[i]._id == this.model) {
          this.ModelName = this.ListModelDetails[i].model.toUpperCase();
        }
      }
      this.newModel_err = false;
      this.loadPartdetails();
      this.modelerr = false;
      this.isValid = true;
    }
  }

  gettechdetails(getTechName) {
    if (getTechName == "" || getTechName == undefined) {
      this.technicianNameerr = true;
    } else {
      this.technicianNameerr = false;
    }
  }

  lastServicetype(getServiceType) {
    if (getServiceType == "" || getServiceType == undefined) {
      this.lastServiceTypeerr = true;
    } else {
      this.lastServiceTypeerr = false;
    }
  }

  getUniqueSerialNumber() {
    // this.loading=true;
    let reqSerObj = {
      serialNumber: this.getSerialNumber,
      orgId: this.orgId,
    };
    return this.http
      .post("/api/CheckSerialNumberExistOrNot", reqSerObj)
      .subscribe(
        (res) => {
          this.loading = false;
          let dataResponse = res.json();
          if (dataResponse.length > 0) {
            this.serialNumberAlreadyExisterr = true;
          } else {
            this.serialNumberAlreadyExisterr = false;
          }
        },
        (err) => {
          // this.loading=false;
        }
      );
  }

  AllowingServices() {
    this.noOFService(this.noofService);
  } //Interval field

  InputFieldCheck(getValue, label) {
    if (label == "SERIAL NUMBER") {
      if (getValue == "" || getValue == undefined) {
        this.getSerialNumber = getValue;
        this.getUniqueSerialNumber();

        this.serialNumbererr = true;
        this.serialNumbercounterr = false;
      } else if (getValue.length > 30) {
        this.getSerialNumber = getValue;
        this.getUniqueSerialNumber();
        this.serialNumbercounterr = true;

        this.serialNumbererr = false;
      } else {
        this.getSerialNumber = getValue;
        this.getUniqueSerialNumber();

        this.serialNumbererr = false;
        this.serialNumbercounterr = false;
      }
    } else if (label == "CLIENT PHONE NUMBER") {
      if (
        this.clientPhonenumber == "" ||
        this.clientPhonenumber == undefined ||
        this.clientPhonenumber == null
      ) {
        this.phonenumbererr = false;
      } else {
        this.phonenumberconuterr = false;
      }
    } else if (label == "MODEL") {
      if (getValue == "" || getValue == undefined) {
        this.modelerr = true;
        this.modelcounterr = false;
      } else {
        this.loadPartdetails();

        this.modelerr = false;
        this.modelcounterr = false;
      }
    } else if (label == "SCHEDULE SERVICE TYPE") {
      if (getValue == "" || getValue == undefined || getValue == null) {
        this.ssterr = true;
      } else {
        this.ssterr = false;
        for (let i = 0; i < this.ListOfSecondFields.length; i++) {
          if (i == 0) {
            //this.ListOfSecondFields[i].sst = this.sst;
          } else {
            //this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) + 250;
            // this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) +parseInt( this.interval);
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
              console.log(this.ListOfSecondFields[i].sst);
            } else {
              // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
            }
          }
        }
      }
    } else if (label == "MC LOCATION") {
      if (getValue == "" || getValue == undefined) {
        this.mcLocationerr = true;
      } else {
        this.mcLocationerr = false;
      }
    } else if (label == "EMAIL") {
      if (getValue == "" || getValue == undefined) {
        this.Validemail_err = true;
      } else {
        this.Validemail_err = false;
      }
    } else if (label == "MAKE") {
      if (getValue == "" || getValue == undefined) {
        this.makeerr = true;
      } else {
        this.makeerr = false;
      }
    } else if (label == "HMR HOURS") {
      if (getValue == "" || getValue == undefined) {
        this.hmrHourserr = true;
        this.hmrHourscounterr = false;
      } else if (getValue.length > 6) {
        this.hmrHourscounterr = true;

        this.hmrHourserr = false;
      } else {
        this.hmrHourscounterr = false;

        this.hmrHourserr = false;
        for (let i = 0; i < this.ListOfSecondFields.length; i++) {
          if (i == 0) {
            this.ListOfSecondFields[i].hmr = this.hmrHours;
          } else {
            //  this.ListOfSecondFields[i].hmr = parseInt(this.ListOfSecondFields[i-1].hmr) + parseInt( this.interval);
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) + 250;
            } else {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) +
                parseInt(this.interval);
            }
          }
        }
      }
    } else if (label == "LAST SERVICE HOURS") {
      if (getValue == "" || getValue == undefined) {
        this.lastServiceHourerr = true;
      } else if (getValue.length > 6) {
        this.lastServiceHourCounterr = true;

        this.lastServiceHourerr = false;
      } else {
        this.lastServiceHourerr = false;
        this.lastServiceHourCounterr = false;
      }
    } else if (label == "LAST SERVICE TYPE") {
      if (getValue == "" || getValue == undefined) {
        this.lastServiceTypeerr = true;
      } else {
        this.lastServiceTypeerr = false;
      }
    } else if (label == "YEAR OF MANUFACTURE") {
      if (getValue == "" || getValue == undefined) {
        this.yearofmanufactureerr = true;
      } else if (getValue.length > 4) {
        this.yearofmanufacturecounterr = true;
        this.yearofmanufactureerr = false;
      } else {
        this.yearofmanufactureerr = false;
        this.yearofmanufacturecounterr = false;
      }
    } else if (label == "SERVICE CONTRACT OFFERED YEAR") {
      if (getValue == "" || getValue == undefined) {
        this.serviceContractOfferederr = true;
      } else if (getValue.length > 4) {
        this.serviceContractcounterr = true;
        this.serviceContractOfferederr = false;
      } else {
        this.serviceContractOfferederr = false;
        this.serviceContractcounterr = false;
      }
    } else if (label == "CONTRACT REFERENCE") {
      if (getValue == "" || getValue == undefined) {
        this.contractReferenceerr = true;
      } else {
        this.contractReferenceerr = false;
      }
    } else if (label == "SERVICE REMAINDER DAY") {
      if (getValue == "" || getValue == undefined) {
        this.serviceremainderdays_err = true;
        this.serviceremainderdaysCount_err = false;
      } else if (
        parseInt(this.serviceRemainderDays) > parseInt(this.intervalofservice)
      ) {
        this.serviceremainderdays_err = false;
        this.serviceremainderdaysCount_err = true;
      } else {
        this.serviceremainderdaysCount_err = false;
        this.serviceremainderdays_err = false;
      }
    }
  }

  // else if(label == 'BRANCH') {
  //     if(getValue == "" || getValue == undefined) {

  //       this.brancherr = true;
  //     }else {

  //       this.brancherr = false;
  //     }
  //   }

  loadPartdetails() {
    this.loading = true;

    if (
      this.make == "" &&
      this.make == undefined &&
      this.model == "" &&
      this.model
    ) {
      this.ListOfFields = [];

      this.loading = false;
    } else {
      let Obj = {
        make: this.make,
        model: this.model,
        orgId: this.orgId,
      };
      return this.http.post("/api/getPartdetails", Obj).subscribe(
        (res) => {
          this.loading = false;
          let resProc = res.json();
          if (resProc.length > 0) {
            this.loading = false;
            this.ListOfFields = resProc[0].Sparedetails;
          } else {
            this.loading = false;

            this.ListOfFields = [];
            this.listServiceType = [];
            for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
              let serviceObj = {
                service: this.ListOfCheckListMaster[i].servicetype,
                check: false,
              };
              this.listServiceType.push(serviceObj);
            }
            this.ListOfFields.push({
              part_Number: "",
              descriptions: "",
              quantity: "",
              unit_Price: "",
              total: "",
              discount: "",
              selling_Price: "",
              service_Type: this.listServiceType,
              cost_Type: "",
            });
          }
        },
        (err) => {
          this.loading = false;
          console.log(err);
        }
      );
    }
  }

  checkServiceList(value) {
    if (value == "" || value == undefined || value == null) {
      this.isValid = false;
      this.serviceValidation = 1;
    } else {
      this.isValid = true;
      this.serviceValidation = 0;
    }
  }

  serviceTypeDetails(service, IndexCount) {
    let sparePrice = 0;
    let consumablePrice = 0;
    this.ListOfSecondFields[IndexCount].consumables = 0;
    this.ListOfSecondFields[IndexCount].spare_Cost = 0;
    for (let s = 0; s < this.ListOfCheckListMaster.length; s++) {
      if (this.ListOfCheckListMaster[s]._id == parseInt(service)) {
        service = this.ListOfCheckListMaster[s].servicetype;
      }
    }
    for (let i = 0; i < this.ListOfFields.length; i++) {
      for (let k = 0; k < this.ListOfFields[i].service_Type.length; k++) {
        if (
          this.ListOfFields[i].service_Type[k].service == service &&
          this.ListOfFields[i].service_Type[k].check == true &&
          this.ListOfFields[i].cost_Type == "SPARE COST"
        ) {
          sparePrice += parseFloat(this.ListOfFields[i].selling_Price);
          this.ListOfSecondFields[IndexCount].spare_Cost =
            sparePrice.toFixed(2);
        } else if (
          this.ListOfFields[i].service_Type[k].service == service &&
          this.ListOfFields[i].service_Type[k].check == true &&
          this.ListOfFields[i].cost_Type == "CONSUMABLES"
        ) {
          consumablePrice += parseFloat(this.ListOfFields[i].selling_Price);
          this.ListOfSecondFields[IndexCount].consumables =
            consumablePrice.toFixed(2);
        }
      }
    }

    let labourcostobj = {
      makeId: this.make,
      modelId: this.model,
      serviceType: this.ListOfSecondFields[IndexCount].service_Type,
      orgId: this.orgId,
    };
    return this.http
      .post("/api/getLabourCostdetailsFORPMS", labourcostobj)
      .subscribe(
        (res) => {
          // this.loading=false;

          let getresponse = res.json();
          if (getresponse.length > 0) {
            this.ListOfSecondFields[IndexCount].labour_Cost =
              getresponse[0].totalLabourCost;
            this.ListOfSecondFields[IndexCount].labour_hour =
              getresponse[0].labourhours;
          } else {
            this.ListOfSecondFields[IndexCount].labour_Cost = 0;
            this.ListOfSecondFields[IndexCount].labour_hour = 0;
          }
        },
        (err) => {
          // this.loading=false;
          this.msgtext = "Unable to find Labour cost";
          this.getWarningFunction(this.msgtext);
        }
      );
  }

  quantity(qValue, IndexQ) {
    this.currentQuantity = qValue;
    this.ListOfFields[IndexQ].total = (
      this.ListOfFields[IndexQ].quantity * this.ListOfFields[IndexQ].unit_Price
    ).toFixed(2);
    this.ListOfFields[IndexQ].selling_Price = (
      this.ListOfFields[IndexQ].quantity * this.ListOfFields[IndexQ].unit_Price
    ).toFixed(2);
  }

  unitPrice(upValue, IndexUP) {
    this.currentUnitPrice = upValue;
    this.ListOfFields[IndexUP].total = (
      this.ListOfFields[IndexUP].quantity *
      this.ListOfFields[IndexUP].unit_Price
    ).toFixed(2);
    this.ListOfFields[IndexUP].selling_Price = (
      this.ListOfFields[IndexUP].quantity *
      this.ListOfFields[IndexUP].unit_Price
    ).toFixed(2);
  }

  discount(discount, Index) {
    if (discount > 100) {
      alert("Discount Percentage Should not greater than 100");
      this.ListOfFields[Index].discount = "";
    } else {
      this.ListOfFields[Index].discount = discount;
      let Price: any = (
        this.ListOfFields[Index].quantity * this.ListOfFields[Index].unit_Price
      ).toFixed(2);
      let priceWithDiscount: any = ((discount / 100) * Price).toFixed(2);
      this.ListOfFields[Index].selling_Price = (
        Price - priceWithDiscount
      ).toFixed(2);
    }
  }

  add() {
    this.listServiceType = [];
    for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
      let serviceObj = {
        service: this.ListOfCheckListMaster[i].servicetype,
        check: false,
      };
      this.listServiceType.push(serviceObj);
    }
    this.ListOfFields.push({
      part_Number: "",
      descriptions: "",
      quantity: "",
      unit_Price: "",
      total: "",
      discount: "",
      selling_Price: "",
      service_Type: this.listServiceType,
      cost_Type: "",
    });
  }

  addSer() {
    this.ListOfSecondFields.push({
      sst: "",
      hmr: "",
      date: "",
      serviceType: "",
      labour_Cost: "",
      labour_hour: "",
      spare_Cost: "",
      travel_Cost: "",
      travel_hour: "",
      consumables: "",
    });
  }

  minusSer(Index) {
    this.ListOfSecondFields.splice(Index, 1);
  }

  minus(Index) {
    this.ListOfFields.splice(Index, 1);
    if (this.ListOfFields.length == 0) {
      this.listServiceType = [];
      for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
        let serviceObj = {
          service: this.ListOfCheckListMaster[i].servicetype,
          check: false,
        };
        this.listServiceType.push(serviceObj);
      }
      this.ListOfFields.push({
        part_Number: "",
        descriptions: "",
        quantity: "",
        unit_Price: "",
        total: "",
        discount: "",
        selling_Price: "",
        service_Type: this.listServiceType,
        cost_Type: "",
      });
    }
  }

  // noOFService(NumberCount) {
  //
  //   this.intervalofservice='';
  //   if(parseInt(NumberCount.length)>2) {
  //     this.disabled=true;
  //     this.noOfserviceCounterr=true;
  //     this.isValid=false;
  //     this.noOfserviceerr=false;
  //     this.ListOfSecondFields = [];
  //     this.ListOfSecondFields.push({
  //       'sst':'',
  //       'hmr':'',
  //       'date':'',
  //       'serviceType':'',
  //       'labour_Cost':'',
  //       'labour_hour':'',
  //       'spare_Cost':'',
  //       'travel_Cost':'',
  //       'travel_hour':'',
  //       'consumables':''
  //       });
  //   } else if(this.noofService == "" || this.noofService == undefined ) {
  //     this.disabled=true;
  //     this.isValid=false;
  //     this.noOfserviceerr=true;
  //     this.noOfserviceCounterr=false;
  //     this.ListOfSecondFields = [];
  //     this.ListOfSecondFields.push({
  //       'sst':'',
  //       'hmr':'',
  //       'date':'',
  //       'serviceType':'',
  //       'labour_Cost':'',
  //       'labour_hour':'',
  //       'spare_Cost':'',
  //       'travel_Cost':'',
  //       'travel_hour':'',
  //       'consumables':''
  //       });
  //   }  else {
  //     this.isValid=true;
  //     this.noOfserviceCounterr=false;
  //     this.disabled=false;
  //     this.noOfserviceerr=false;
  //     this.ListOfSecondFields = [];
  //     for(var i=0;i<NumberCount;i++) {

  //       this.ListOfSecondFields.push({
  //         'sst':'',
  //         'hmr':'',
  //         'date':'',
  //         'serviceType':'',
  //         'labour_Cost':'',
  //         'labour_hour':'',
  //         'spare_Cost':'',
  //         'travel_Cost':'',
  //         'travel_hour':'',
  //         'consumables':''
  //       });
  //       if(this.route.params['value'].renewal == 'yes') {
  //         this.ListOfSecondFields[i].travel_Cost = this.RenewalTravelCost;
  //         this.ListOfSecondFields[i].travel_hour = this.RenewalTravelHours;
  //       } else {
  //         this.ListOfSecondFields[i].travel_Cost = this.Price;
  //         this.ListOfSecondFields[i].travel_hour = this.Finalmins;
  //       }

  //       if(this.hmrHours == "" || this.hmrHours == null || this.hmrHours == undefined) {
  //         this.hmrHourserr=false;
  //         if(i == 0) {
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //             this.ListOfSecondFields[i].hmr = 250;
  //             console.log(this.ListOfSecondFields[i].sst);
  //           }else{
  //             this.ListOfSecondFields[i].hmr = this.interval;
  //           }
  //         } else {
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //               this.ListOfSecondFields[i].hmr =  parseInt(this.ListOfSecondFields[i-1].hmr) +250;

  //             }else{
  //               this.ListOfSecondFields[i].hmr =  parseInt(this.ListOfSecondFields[i-1].hmr) +parseInt(this.interval);
  //             }
  //           // this.ListOfSecondFields[i].hmr = parseInt(this.ListOfSecondFields[i-1].hmr) + parseInt(this.interval);
  //         }
  //         this.hmrHours = this.ListOfSecondFields[0].hmr
  //       } else {
  //         this.hmrHourserr=false;
  //         if(i == 0) {
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //             this.ListOfSecondFields[i].hmr = 250;
  //             console.log(  this.ListOfSecondFields[i].sst)
  //           }else{
  //             this.ListOfSecondFields[i].hmr = this.interval;
  //           }

  //         } else {
  //           // this.ListOfSecondFields[i].hmr = parseInt(this.ListOfSecondFields[i-1].hmr) +parseInt(this.interval) ;
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //               this.ListOfSecondFields[i].hmr =  parseInt(this.ListOfSecondFields[i-1].hmr) +250;

  //             }else{
  //               this.ListOfSecondFields[i].hmr =  parseInt(this.ListOfSecondFields[i-1].hmr) +parseInt(this.interval);
  //             }
  //         }
  //         this.hmrHours = this.ListOfSecondFields[0].hmr//
  //       }

  //       if(this.sst == "" || this.sst == null || this.sst == undefined) {
  //         this.ssterr=false;
  //         if(i == 0) {
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //             this.ListOfSecondFields[i].sst = 250;
  //             console.log(  this.ListOfSecondFields[i].sst)
  //           }else{
  //             this.ListOfSecondFields[i].sst = this.interval;
  //           }
  //         } else {
  //           // this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) + parseInt(this.interval);
  //           if(this.interval==null||this.interval==undefined||this.interval==""){

  //             this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
  //             console.log(  this.ListOfSecondFields[i].sst)
  //           }else{
  //              this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
  //           }
  //         }
  //         this.sst = this.ListOfSecondFields[0].sst
  //       } else {
  //         this.ssterr=false;
  //         if(i == 0) {
  //           if(this.interval==null||this.interval==undefined||this.interval==""){
  //             this.ListOfSecondFields[i].sst = 250;
  //             console.log(  this.ListOfSecondFields[i].sst)
  //           }else{
  //             this.ListOfSecondFields[i].sst = this.interval;
  //           }
  //         } else {
  //           // this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) + parseInt(this.interval);
  //           if(this.interval==null||this.interval==undefined||this.interval==""){

  //             this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
  //             console.log(  this.ListOfSecondFields[i].sst)
  //           }else{
  //              this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
  //           }
  //         }
  //         this.sst = this.ListOfSecondFields[0].sst//
  //       }
  //     }
  //   }

  // }
  noOFService(NumberCount) {
    this.intervalofservice = "";
    let sstvalue = 0;
    if (parseInt(NumberCount.length) > 2) {
      this.disabled = true;
      this.noOfserviceCounterr = true;
      this.isValid = false;
      this.noOfserviceerr = false;
      this.ListOfSecondFields = [];
      this.ListOfSecondFields.push({
        sst: "",
        hmr: "",
        date: "",
        serviceType: "",
        labour_Cost: "",
        labour_hour: "",
        spare_Cost: "",
        travel_Cost: "",
        travel_hour: "",
        consumables: "",
      });
    } else if (this.noofService == "" || this.noofService == undefined) {
      this.disabled = true;
      this.isValid = false;
      this.noOfserviceerr = true;
      this.noOfserviceCounterr = false;
      this.ListOfSecondFields = [];
      this.ListOfSecondFields.push({
        sst: "",
        hmr: "",
        date: "",
        serviceType: "",
        labour_Cost: "",
        labour_hour: "",
        spare_Cost: "",
        travel_Cost: "",
        travel_hour: "",
        consumables: "",
      });
    } else {
      this.isValid = true;
      this.noOfserviceCounterr = false;
      this.disabled = false;
      this.noOfserviceerr = false;
      this.ListOfSecondFields = [];
      for (var i = 0; i < NumberCount; i++) {
        this.ListOfSecondFields.push({
          sst: "",
          hmr: "",
          date: "",
          serviceType: "",
          labour_Cost: "",
          labour_hour: "",
          spare_Cost: "",
          travel_Cost: "",
          travel_hour: "",
          consumables: "",
        });
        if (this.route.params["value"].renewal == "yes") {
          this.ListOfSecondFields[i].travel_Cost = this.RenewalTravelCost;
          this.ListOfSecondFields[i].travel_hour = this.RenewalTravelHours;
        } else {
          this.ListOfSecondFields[i].travel_Cost = this.Price;
          this.ListOfSecondFields[i].travel_hour = this.Finalmins;
        }

        if (
          this.hmrHours == "" ||
          this.hmrHours == null ||
          this.hmrHours == undefined
        ) {
          this.hmrHourserr = false;
          if (i == 0) {
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].hmr = 250;
              console.log(this.ListOfSecondFields[i].sst);
            } else {
              this.ListOfSecondFields[i].hmr = this.interval;
            }
          } else {
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) + 250;
            } else {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) +
                parseInt(this.interval);
            }
            // this.ListOfSecondFields[i].hmr = parseInt(this.ListOfSecondFields[i-1].hmr) + parseInt(this.interval);
          }
          this.hmrHours = this.ListOfSecondFields[0].hmr;
        } else {
          this.hmrHourserr = false;
          if (i == 0) {
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].hmr = 250;
              console.log(this.ListOfSecondFields[i].sst);
            } else {
              this.ListOfSecondFields[i].hmr = this.interval;
            }
          } else {
            // this.ListOfSecondFields[i].hmr = parseInt(this.ListOfSecondFields[i-1].hmr) +parseInt(this.interval) ;
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) + 250;
            } else {
              this.ListOfSecondFields[i].hmr =
                parseInt(this.ListOfSecondFields[i - 1].hmr) +
                parseInt(this.interval);
            }
          }
          this.hmrHours = this.ListOfSecondFields[0].hmr; //
        }

        if (this.sst == "" || this.sst == null || this.sst == undefined) {
          this.ssterr = false;
          // if(i == 0) {
          //   if(this.interval==null||this.interval==undefined||this.interval==""){
          //     for(let i=0;i<this.ListOfCheckListMaster.length;i++){
          //       if(this.sst==this.ListOfCheckListMaster[i]._id){
          //         this.sst =this.ListOfCheckListMaster[i].servicetype;
          //       }
          //     }
          //     this.ListOfSecondFields[i].sst = this.sst ;
          //     console.log(  this.ListOfSecondFields[i].sst)
          //   }else{
          //    // this.ListOfSecondFields[i].sst = this.interval;
          //   }
          // } else {
          //   // this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) + parseInt(this.interval);
          //   if(this.interval==null||this.interval==undefined||this.interval==""){

          //    // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
          //    for(let j=0;i<this.ListOfCheckListMaster.length;j++){
          //     if(this.ListOfCheckListMaster[j].servicetype==this.sst){
          //      this.ListOfSecondFields[i].sst =  this.ListOfCheckListMaster[j+1].servicetype
          //     }
          //   }
          //     console.log(  this.ListOfSecondFields[i].sst)
          //   }else{
          //    //  this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
          //    for(let i=0;i<this.ListOfCheckListMaster.length;i++){
          //     if(this.ListOfCheckListMaster[i].servicetype==this.sst){
          //      this.ListOfSecondFields[i].sst =  this.ListOfCheckListMaster[i+1].servicetype
          //     }
          //   }
          //   }
          // }
          // this.sst = this.ListOfSecondFields[0].sst
        } else {
          this.ssterr = false;
          if (i == 0) {
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              this.ListOfSecondFields[i].sst = this.sst;
              sstvalue = this.sst;
              console.log(this.ListOfSecondFields[i].sst);
            } else {
              //this.ListOfSecondFields[i].sst = this.interval;
            }
          } else {
            // this.ListOfSecondFields[i].sst = parseInt(this.ListOfSecondFields[i-1].sst) + parseInt(this.interval);
            if (
              this.interval == null ||
              this.interval == undefined ||
              this.interval == ""
            ) {
              //  this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
              for (let j = 0; j < this.ListOfCheckListMaster.length; j++) {
                if (j < this.ListOfCheckListMaster.length) {
                  if (this.ListOfCheckListMaster[j].servicetype == sstvalue) {
                    this.ListOfSecondFields[i].sst =
                      this.ListOfCheckListMaster[j + 1].servicetype;
                  }
                }
              }
              console.log(this.ListOfSecondFields[i].sst);
            } else {
              // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
              for (let j = 0; j < this.ListOfCheckListMaster.length; j++) {
                if (this.ListOfCheckListMaster[j].servicetype == sstvalue) {
                  this.ListOfSecondFields[i].sst =
                    this.ListOfCheckListMaster[j + 1].servicetype;
                }
              }
            }
          }

          this.sst = this.ListOfSecondFields[0].sst; //
          sstvalue = this.ListOfSecondFields[i].sst;
        }
      }
    }
  }

  onchangehmr(value, index) {
    for (let i = index; i < this.ListOfSecondFields.length; i++) {
      if (i == index) {
      } else {
        //  this.ListOfSecondFields[i].hmr =  parseInt(this.ListOfSecondFields[i-1].hmr) +parseInt(this.interval);
        if (
          this.interval == null ||
          this.interval == undefined ||
          this.interval == ""
        ) {
          this.ListOfSecondFields[i].hmr =
            parseInt(this.ListOfSecondFields[i - 1].hmr) + 250;
        } else {
          this.ListOfSecondFields[i].hmr =
            parseInt(this.ListOfSecondFields[i - 1].hmr) +
            parseInt(this.interval);
        }
      }
    }
  }

  onchangeSST(value, index) {
    for (let i = index; i < this.ListOfSecondFields.length; i++) {
      if (i == index) {
      } else {
        // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250
        //this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
        if (
          this.interval == null ||
          this.interval == undefined ||
          this.interval == ""
        ) {
          // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +250;
          console.log(this.ListOfSecondFields[i].sst);
        } else {
          // this.ListOfSecondFields[i].sst =  parseInt(this.ListOfSecondFields[i-1].sst) +parseInt(this.interval);
        }
      }
    }
  }

  noOFServiceContractYear(year) {
    this.startdate = "";
    this.endDate = "";
    this.noofService = "";
    this.intervalofservice = "";
    //this.serviceRemainderDays='';
    if (
      this.noofServiceContractYear == "" ||
      this.noofServiceContractYear == undefined ||
      this.noofServiceContractYear == null
    ) {
      this.SYdisabled = true;
      this.isValid = false;
      this.noOFServiceContractYearerr = true;
      this.noOFServiceContractYearCounterr = false;
    } else if (year > 5) {
      this.noOFServiceContractYearerr = false;
      this.noOFServiceContractYearCounterr = true;
      this.isValid = false;
      this.SYdisabled = true;
    } else {
      this.SYdisabled = false;
      this.isValid = true;
      this.noOFServiceContractYearCounterr = false;
      this.noOFServiceContractYearerr = false;
    }
  }

  getEmptyAllField() {
    this.ClientNamePlaceholder = "CHOOSE CLIENT NAME";
    this.ServiceContractyearsPlaceholder = "SERVICE CONTRACT YEARS";
    this.MakePlaceholder = "CHOOSE THE MAKE";
    this.ModelPlaceholder = "CHOOSE THE MODEL";
    this.ServiceRemainderPlaceholder = "SERVICE REMAINDER DAYS";
    this.TechnicianNamePlaceholder = "CHOOSE TECHNICIAN NAME";
    this.LastServiceTypePlaceholder = "LAST SERVICE TYPE";
    this.YearofManufacturePlaceholder = "YEAR OF MANUFACTURE";
    this.ServiceContracttplaceholder = "SERVICE CONTRACT OFFERED YEAR";
    this.BranchPlaceholder = "CHOOSE THE BRANCH";
    this.emiratesedit = "SELECT THE EMIRATES";
    this.subLocalityedit = "SELECT THE SUBLOCALITY";
    this.ScheduleServiceTypePlaceholder = "SCHEDULE SERVICE TYPE";
    this.expanded = false;
    this.FileShow = "";
    this.downloaderr = false;
    this.serviceValidation = 0;
    this.ListOfFields = [];
    this.PmaCategory = "";
    this.PmaCategoryplaceholder = "PMA CATEGORY";
    this.contractLevel = 1;
    this.ListOfSecondFields = [];
    this.listServiceType = [];
    this.Modeldropdown = [];
    this.originalEndDate = "";
    //this.Makedropdown=[];
    for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
      let serviceObj = {
        service: this.ListOfCheckListMaster[i].servicetype,
        check: false,
      };
      this.listServiceType.push(serviceObj);
    }
    this.ListOfFields.push({
      part_Number: "",
      descriptions: "",
      quantity: "",
      unit_Price: "",
      total: "",
      discount: "",
      selling_Price: "",
      service_Type: this.listServiceType,
      cost_Type: "",
    });
    this.ListOfSecondFields.push({
      sst: "",
      hmr: "",
      date: "",
      serviceType: "",
      labour_Cost: "",
      labour_hour: "",
      spare_Cost: "",
      travel_Cost: "",
      travel_hour: "",
      consumables: "",
    });
    this.clientName = "";
    this.interval = "";
    this.serviceRemainderDays = "";
    this.serialnumber = "";
    this.mclocation = "";
    this.noofService = "";
    this.startdate = "";
    this.endDate = "";
    this.make = "";
    this.intervalofservice = "";
    this.model = "";
    this.hmrHours = "";
    this.sst = "";
    this.emirates = "";
    this.subLocality = "";
    this.technicianName = "";
    this.lastServiceType = "";
    this.lastServiceHour = "";
    this.yearofmanufacturer = "";
    this.branch = "";
    this.serviceContractOffered = "";
    this.contractReference = "";
    this.clientPhonenumber = "";
    this.email = "";
    this.noofServiceContractYear = "";
    this.serviceScheduleNumber = 1;
    this.renewalPMAC = false;
    this.lastServiceStatus = true;
    this.editcontractStatus = false;
  }

  _keyPress(event: any) {
    // if(event.key) {

    // }
    if (event.keyCode == 8) {
      return true;
    } else {
      const pattern = /[0-9\.\ ]/;
      let inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  startDate(start) {
    if (start == "" || start == undefined) {
      this.startdateerr = true;
      this.isValid = false;
    } else {
      this.isValid = true;
      this.startdateerr = false;
    }
    let year: moment.unitOfTime.DurationConstructor = "year";
    // let days:moment.unitOfTime.DurationConstructor = 'Days';
    let addYear = moment(start)
      .add(this.noofServiceContractYear, year)
      .format("YYYY-MM-DD");
    //let enddate = moment(addYear).subtract(1, 'days').format('YYYY-MM-DD');
    this.endDate = addYear;
    if (
      this.noofService == "" ||
      this.noofService == undefined ||
      this.startdate == "" ||
      this.startdate == undefined ||
      this.endDate == "" ||
      this.startdate == undefined
    ) {
      this.disabled = true;
    } else {
      this.disabled = false;
      for (var i = 0; i < this.ListOfSecondFields.length; i++) {
        let addValue = this.intervalofservice * i;
        this.ListOfSecondFields[i].date = moment(this.startdate)
          .add(addValue, "days")
          .format("YYYY-MM-DD");
      }
    }
  }

  InputIntervalService(valueCount) {
    if (
      this.clientName == "" ||
      this.clientName == undefined ||
      this.serialnumber == "" ||
      this.serialnumber == undefined ||
      this.mclocation == "" ||
      this.mclocation == undefined ||
      this.noofService == "" ||
      this.noofService == undefined ||
      this.startdate == "" ||
      this.startdate == undefined ||
      this.endDate == "" ||
      this.endDate == undefined ||
      this.make == "" ||
      this.make == undefined ||
      this.intervalofservice == "" ||
      this.intervalofservice == undefined ||
      this.model == "" ||
      this.model == undefined ||
      this.hmrHours == "" ||
      this.hmrHours == undefined ||
      this.technicianName == "" ||
      this.technicianName == undefined ||
      this.lastServiceType == "" ||
      this.lastServiceType == undefined ||
      this.lastServiceHour == "" ||
      this.lastServiceHour == undefined ||
      this.yearofmanufacturer == "" ||
      this.yearofmanufacturer == undefined ||
      this.branch == "" ||
      this.branch == undefined ||
      this.serviceContractOffered == "" ||
      this.serviceContractOffered == undefined ||
      this.contractReference == "" ||
      this.contractReference == undefined ||
      this.clientPhonenumber == "" ||
      this.clientPhonenumber == undefined ||
      this.email == "" ||
      this.email == undefined
    ) {
    } else {
    }

    if (
      this.intervalofservice == "" ||
      this.intervalofservice == null ||
      this.intervalofservice == undefined
    ) {
      this.intervalofserviceerr = true;
    } else {
      this.intervalofserviceerr = false;
      let count = valueCount * parseInt(this.noofService);
      if (count > 365 * parseInt(this.noofServiceContractYear)) {
        let requiredNumber =
          (365 * parseInt(this.noofServiceContractYear)) / this.noofService;
        this.intervalofservice = "";
        alert(
          "Interval Service days Should not greater than " +
            requiredNumber.toString().split(".")[0]
        );

        for (var i = 0; i < this.ListOfSecondFields.length; i++) {
          this.ListOfSecondFields[i].date = "";
        }
      }
      for (var i = 0; i < this.ListOfSecondFields.length; i++) {
        let addValue = valueCount * i;
        if (
          moment(this.startdate).add(addValue, "days").format("dddd") ==
          "Friday"
        ) {
          this.ListOfSecondFields[i].date = moment(this.startdate)
            .add(addValue + 1, "days")
            .format("YYYY-MM-DD");
        } else {
          this.ListOfSecondFields[i].date = moment(this.startdate)
            .add(addValue, "days")
            .format("YYYY-MM-DD");
        }
      }
    }
  }

  serviceDate(date, IndexCount) {
    if (date == null || date == undefined || date == "") {
      this.isValid = false;
      this.serviceValidation = 0;
    } else {
      this.isValid = true;
      this.serviceValidation = 1;
    }

    for (var i = IndexCount + 1; i < this.ListOfSecondFields.length; i++) {
      let addValue = this.intervalofservice;
      if (i > 0) {
        this.ListOfSecondFields[i].date = moment(
          this.ListOfSecondFields[i - 1].date
        )
          .add(addValue, "days")
          .format("YYYY-MM-DD");
      } else if (i == 0) {
        this.ListOfSecondFields[i].date = moment(
          this.ListOfSecondFields[i].date
        )
          .add(addValue, "days")
          .format("YYYY-MM-DD");
      }
    }

    if (
      this.ListOfSecondFields[this.ListOfSecondFields.length - 1].date >
        this.endDate ||
      this.ListOfSecondFields[this.ListOfSecondFields.length - 1].date <
        this.startdate
    ) {
      alert(
        "Service Date should be Under service Contract Start date and End date"
      );
      for (var i = IndexCount; i < this.ListOfSecondFields.length; i++) {
        this.ListOfSecondFields[i].date = "";
      }
    } else {
    }
  }

  reset() {
    this.getEmptyAllField();
  }

  // else if(this.sst == "" || this.sst == undefined) {

  //       this.ssterr=true;
  //       this.loading=false;
  //       document.body.scrollTop = 0;
  //       document.documentElement.scrollTop = 0;
  //     }

  // else if(this.hmrHours == "" || this.hmrHours == undefined) {

  //       this.hmrHourserr=true;
  //       this.loading=false;
  //       document.body.scrollTop = 0;
  //       document.documentElement.scrollTop = 0;
  //     }
  // else if(this.branch == "" || this.branch == undefined) {

  //       this.brancherr=true;
  //       this.loading=false;
  //       document.body.scrollTop = 0;
  //       document.documentElement.scrollTop = 0;
  //     }
  Submit() {
    this.loading = true;
    this.partsValidation = 0;
    this.serviceValidation = 0;
    this.uploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
    };
    this.uploader.onCompleteItem = (
      item: any,
      response: any,
      status: any,
      headers: any
    ) => {
      console.log("ImageUpload:uploaded:", item, status, response);
    };

    for (let s = 0; s < this.ListOfSecondFields.length; s++) {
      if (
        this.ListOfSecondFields[s].sst == null ||
        this.ListOfSecondFields[s].sst == "" ||
        this.ListOfSecondFields[s].sst == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].date == null ||
        this.ListOfSecondFields[s].date == "" ||
        this.ListOfSecondFields[s].date == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].service_Type == null ||
        this.ListOfSecondFields[s].service_Type == "" ||
        this.ListOfSecondFields[s].service_Type == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].labour_Cost == null ||
        this.ListOfSecondFields[s].labour_Cost == "" ||
        this.ListOfSecondFields[s].labour_Cost == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].travel_Cost == null ||
        this.ListOfSecondFields[s].travel_Cost == "" ||
        this.ListOfSecondFields[s].travel_Cost == undefined
      ) {
        this.serviceValidation = 1;
      }
    }

    for (let pt = 0; pt < this.ListOfFields.length; pt++) {
      if (
        this.ListOfFields[pt].descriptions == null ||
        this.ListOfFields[pt].descriptions == "" ||
        this.ListOfFields[pt].descriptions == undefined ||
        this.ListOfFields[pt].quantity == null ||
        this.ListOfFields[pt].quantity == "" ||
        this.ListOfFields[pt].quantity == undefined ||
        this.ListOfFields[pt].unit_Price == null ||
        this.ListOfFields[pt].unit_Price == "" ||
        this.ListOfFields[pt].unit_Price == undefined ||
        this.ListOfFields[pt].total == null ||
        this.ListOfFields[pt].total == "" ||
        this.ListOfFields[pt].total == undefined ||
        this.ListOfFields[pt].selling_Price == null ||
        this.ListOfFields[pt].selling_Price == "" ||
        this.ListOfFields[pt].selling_Price == undefined ||
        this.ListOfFields[pt].cost_Type == null ||
        this.ListOfFields[pt].cost_Type == undefined ||
        this.ListOfFields[pt].cost_Type == ""
      ) {
        this.partsValidation = 1;
      } else {
        this.partsValidation = 0;
      }
    }

    if (this.clientName == "" || this.clientName == undefined) {
      this.clienterr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.serialnumber == "" || this.serialnumber == undefined) {
      this.serialNumbererr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.emirates == "" || this.emirates == undefined) {
      this.newEmirate_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.subLocality == "" || this.subLocality == undefined) {
      this.newsubLocality_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.mclocation == "" || this.mclocation == undefined) {
      this.mcLocationerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.make == "" || this.make == undefined) {
      this.makeerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.model == "" || this.model == undefined) {
      this.modelerr = true;
      document.body.scrollTop = 0;
      this.loading = false;
      document.documentElement.scrollTop = 0;
    } else if (this.technicianName == "" || this.technicianName == undefined) {
      this.loading = false;
      this.technicianNameerr = true;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.lastServiceType == "" ||
      this.lastServiceType == undefined
    ) {
      this.lastServiceTypeerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.lastServiceHour == "" ||
      this.lastServiceHour == undefined
    ) {
      this.lastServiceHourerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.yearofmanufacturer == "" ||
      this.yearofmanufacturer == undefined
    ) {
      this.yearofmanufactureerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.serviceContractOffered == "" ||
      this.serviceContractOffered == undefined
    ) {
      this.serviceContractOfferederr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.contractReference == "" ||
      this.contractReference == undefined
    ) {
      this.contractReferenceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.noofServiceContractYear == "" ||
      this.noofServiceContractYear == undefined
    ) {
      this.noOFServiceContractYearerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.startdate == "" || this.startdate == undefined) {
      this.startdateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.endDate == "" || this.endDate == undefined) {
      this.enddateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.originalEndDate == "" ||
      this.originalEndDate == undefined
    ) {
      this.originalenddateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.noofService == "" || this.noofService == undefined) {
      this.noOfserviceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.intervalofservice == "" ||
      this.intervalofservice == undefined
    ) {
      this.intervalofserviceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.serviceRemainderDays == "" ||
      this.serviceRemainderDays == undefined
    ) {
      this.serviceremainderdays_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.ListOfSecondFields[0].date == "" ||
      this.ListOfSecondFields[0].date == null ||
      this.ListOfSecondFields[0].date == undefined
    ) {
      //alert('pls enter the First service date');
    } else if (this.partsValidation == 1) {
      this.loading = false;
      alert("please fill the parts details");
    } else if (this.serialNumberAlreadyExisterr == true) {
      alert("This Serial Number already Exists");
    } else if (this.serviceValidation == 1) {
      alert("please fill the service details");
      this.loading = false;
    } else if (this.uploader.queue.length == 0) {
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.FileData = null;
      $("#addConfirmations").modal("show");
    } else {
      this.FileData = this.uploader.queue[0].file.name;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      $("#addConfirmations").modal("show");
    }
  }

  yes() {
    $("#addConfirmations").modal("hide");
    this.addPMSContract();
  }

  async addPMSContract() {
  debugger;
  this.loading = true;
  let reqObj = {
    pmacategory: this.PmaCategory,
    client_Name: this.clientName,
    serial_Number: this.serialnumber,
    mcLocation: this.mclocation,
    no_Of_Service: this.noofService,
    start_Date: this.startdate,
    end_Date: this.endDate,
    make: this.make,
    days_Interval_Of_Service: this.intervalofservice,
    model: this.model,
    hmr: this.hmrHours,
    sst: this.sst,
    emirates: this.emirates,
    original_end_date: this.originalEndDate,
    subLocality: this.subLocality,
    technician_Name: this.technicianName,
    last_Service_Type: this.lastServiceType,
    last_Service_Hours: this.lastServiceHour,
    year_Of_manufacturer: this.yearofmanufacturer,
    branch: this.branch,
    service_Contract_Offered: this.serviceContractOffered,
    contract_Reference: this.contractReference,
    phone_Number: this.clientPhonenumber,
    email: this.email,
    remainderday: this.serviceRemainderDays,
    noofServiceContractYear: this.noofServiceContractYear,
    SpareValues: this.ListOfFields,
    Servicevalues: this.ListOfSecondFields,
    locality: this.locality,
    interval: this.interval,
    fileName: this.FileData,
    contractLevel: this.contractLevel,
    orgId: this.orgId,
    created_By: this.userId,
    created_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
  };
  return this.http
    .post("/api/addPreventiveMaintenanceService", reqObj)
    .subscribe(
      (res) => {
        console.log(res);
        this.loading = false;
        let resProc = res.json();
        let days = this.serviceRemainderDays;
        let serviceDate = this.ListOfSecondFields[0].date;
        let Remainder = moment(serviceDate)
          .subtract(days, "Days")
          .format("YYYY-MM-DD");

        let next_Service_Type = null;
        if (
          this.ListOfSecondFields[1] &&
          this.ListOfSecondFields[1].service_Type
        ) {
          next_Service_Type = this.ListOfSecondFields[1].service_Type;
        }

        let next_Service_Remainder_day = null;
        if (this.serviceRemainderDays) {
          next_Service_Remainder_day = this.serviceRemainderDays;
        }

        let reqObj = {
          pm_Id: resProc._id,
          serialNumber: this.serialnumber,
          schedularNumber: 0,
          service_Scheduler_Number: 0,
          service_CarriedOut_Date: this.ListOfSecondFields[0].date,
          next_Service_Remainder_day: next_Service_Remainder_day,
          next_Service_Type: next_Service_Type,
          Remainderdate: Remainder,
          service_Type: this.ListOfSecondFields[0].service_Type,
          contractLevel: this.contractLevel,
          mcLocation: this.mclocation,
          locality: this.locality,
          branch: this.locality,
          Servicedetails: this.ListOfSecondFields,
          orgId: this.orgId,
          created_By: this.userId,
          created_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
        };
        return this.http
          .post("/api/addServiceFormContractCreation", reqObj)
          .subscribe(
            async (res) => {
              this.loading = false;
              res.json();
              let nextSeviceType;
              for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
                if (
                  parseInt(this.ListOfSecondFields[0].service_Type) ==
                  this.ListOfCheckListMaster[i]._id
                ) {
                  nextSeviceType = this.ListOfCheckListMaster[i].servicetype;
                }
              }

              // Load customer and machine details
              const { customerName, makeName, modelName } =
                await this.loadCustomerAndMachineDetails();

              let ReqObj = {
                SCHEDULE_DATE: this.ListOfSecondFields[0].date,
                userId: this.technicianName,
                MachineNumber: this.serialnumber,
                customerName: customerName, // Use fetched customer name
                phoneNumber: this.clientPhonenumber,
                machineMake: makeName, // Use fetched make name
                machineModel: modelName, // Use fetched model name
                PMId: resProc._id,
                RemainderDate: Remainder,
                CREATED_DATE: moment().format("YYYY-MM-DD"),
                lastserviceType: "This is First Service",
                lastserviceHmr: "This is First Service",
                nextserviceHmr: this.ListOfSecondFields[0].hmr,
                nextservicetype: nextSeviceType,
                nextServicedate: this.ListOfSecondFields[0].date,
                lastServiceDate: null,
                orgId: this.orgId,
                created_By: this.userId,
                original_end_date: this.originalEndDate,
                created_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
              };
              return this.http
                .post("/api/PMSNotifications", ReqObj)
                .subscribe((res) => {
                  this.loading = false;
                  let resProc = res.json();
                  this.getEmptyAllField();
                  document.body.scrollTop = 0;
                  document.documentElement.scrollTop = 0;
                  this.router.navigate([
                    "node/preventiveMaintenance",
                    { orgId: this.orgId, userId: this.userId },
                  ]);
                  $("#Newadd").modal("show");
                });
            },
            (err) => {
              this.loading = false;
              this.msgtext = "Unable to Add the Data";
              this.getWarningFunction(this.msgtext);
            }
          );
      },
      (err) => {
        this.loading = false;
        this.msgtext = "Unable to Add the Data";
        this.getWarningFunction(this.msgtext);
      }
    );
}

  update() {
    this.loading = true;
    this.serviceValidation = 0;
    for (let s = 0; s < this.ListOfSecondFields.length; s++) {
      if (
        this.ListOfSecondFields[s].date == null ||
        this.ListOfSecondFields[s].date == "" ||
        this.ListOfSecondFields[s].date == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].service_Type == null ||
        this.ListOfSecondFields[s].service_Type == "" ||
        this.ListOfSecondFields[s].service_Type == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].labour_Cost == null ||
        this.ListOfSecondFields[s].labour_Cost == "" ||
        this.ListOfSecondFields[s].labour_Cost == undefined
      ) {
        this.serviceValidation = 1;
      } else if (
        this.ListOfSecondFields[s].travel_Cost == null ||
        this.ListOfSecondFields[s].travel_Cost == "" ||
        this.ListOfSecondFields[s].travel_Cost == undefined
      ) {
        this.serviceValidation = 1;
      }
    }
    if (this.clientName == "" || this.clientName == undefined) {
      this.clienterr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.serialnumber == "" || this.serialnumber == undefined) {
      this.serialNumbererr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.emirates == "" || this.emirates == undefined) {
      this.newEmirate_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.subLocality == "" || this.subLocality == undefined) {
      this.newsubLocality_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.mclocation == "" || this.mclocation == undefined) {
      this.mcLocationerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.make == "" || this.make == undefined) {
      this.makeerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.model == "" || this.model == undefined) {
      this.modelerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.technicianName == "" || this.technicianName == undefined) {
      this.technicianNameerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.sst == "" || this.sst == undefined) {
      this.ssterr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.hmrHours == "" || this.hmrHours == undefined) {
      this.hmrHourserr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.lastServiceType == "" ||
      this.lastServiceType == undefined
    ) {
      this.lastServiceTypeerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.lastServiceHour == "" ||
      this.lastServiceHour == undefined
    ) {
      this.lastServiceHourerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.yearofmanufacturer == "" ||
      this.yearofmanufacturer == undefined
    ) {
      this.yearofmanufactureerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.branch == "" || this.branch == undefined) {
      this.brancherr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.serviceContractOffered == "" ||
      this.serviceContractOffered == undefined
    ) {
      this.serviceContractOfferederr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.contractReference == "" ||
      this.contractReference == undefined
    ) {
      this.contractReferenceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.noofServiceContractYear == "" ||
      this.noofServiceContractYear == undefined
    ) {
      this.noOFServiceContractYearerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.startdate == "" || this.startdate == undefined) {
      this.startdateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.endDate == "" || this.endDate == undefined) {
      this.enddateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.originalEndDate == "" ||
      this.originalEndDate == undefined
    ) {
      this.originalenddateerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (this.noofService == "" || this.noofService == undefined) {
      this.noOfserviceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.intervalofservice == "" ||
      this.intervalofservice == undefined
    ) {
      this.intervalofserviceerr = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.serviceRemainderDays == "" ||
      this.serviceRemainderDays == undefined
    ) {
      this.serviceremainderdays_err = true;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    } else if (
      this.ListOfSecondFields[0].date == "" ||
      this.ListOfSecondFields[0].date == null ||
      this.ListOfSecondFields[0].date == undefined
    ) {
      //alert('pls enter the First service date');
      alert("please fill the service details");
      this.loading = false;
    } else if (this.serviceValidation == 1) {
      alert("please fill the service details");
      this.loading = false;
    } else if (this.uploader.queue.length == 0) {
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.FileData = null;
      $("#updateConfirmation").modal("show");
    } else {
      this.FileData = this.uploader.queue[0].file.name;
      this.loading = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      $("#updateConfirmation").modal("show");
    }
  }

  upyes() {
    $("#updateConfirmation").modal("hide");
    this.updatePMSContract();
  }

  async updatePMSContract() {
  this.loading = true;
  let reqObj = {
    pmacategory: this.PmaCategory,
    PMId: this.preventiveId,
    orgId: this.orgId,
    client_Name: this.clientName,
    serial_Number: this.serialnumber,
    mcLocation: this.mclocation,
    no_Of_Service: this.noofService,
    start_Date: this.startdate,
    end_Date: this.endDate,
    make: this.make,
    days_Interval_Of_Service: this.intervalofservice,
    original_end_date: this.originalEndDate,
    model: this.model,
    hmr: this.hmrHours,
    sst: this.sst,
    emirates: this.emirates,
    subLocality: this.subLocality,
    technician_Name: this.technicianName,
    last_Service_Type: this.lastServiceType,
    last_Service_Hours: this.lastServiceHour,
    year_Of_manufacturer: this.yearofmanufacturer,
    branch: this.branch,
    service_Contract_Offered: this.serviceContractOffered,
    contract_Reference: this.contractReference,
    phone_Number: this.clientPhonenumber,
    email: this.email,
    remainderday: this.serviceRemainderDays,
    noofServiceContractYear: this.noofServiceContractYear,
    SpareValues: this.ListOfFields,
    fileName: this.FileData,
    contractLevel: this.contractLevel,
    Servicevalues: this.ListOfSecondFields,
    updated_By: this.userId,
    updated_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
  };
  return this.http.post("/api/updatePMSContractDetails", reqObj).subscribe(
    (res) => {
      let days = this.serviceRemainderDays;
      let serviceDate =
        this.ListOfSecondFields[this.serviceScheduleNumber - 1].date;
      let Remainder = moment(serviceDate)
        .subtract(days, "Days")
        .format("YYYY-MM-DD");
      let reqObj = {
        pm_Id: this.preventiveId,
        serialNumber: this.serialnumber,
        schedularNumber: this.serviceScheduleNumber,
        service_CarriedOut_Date:
          this.ListOfSecondFields[this.serviceScheduleNumber - 1].date,
        next_Service_Remainder_day: this.serviceRemainderDays,
        next_Service_Type:
          this.ListOfSecondFields[this.serviceScheduleNumber].service_Type,
        Remainderdate: Remainder,
        service_Type:
          this.ListOfSecondFields[this.serviceScheduleNumber - 1].service_Type,
        contractLevel: this.contractLevel,
        mcLocation: this.mclocation,
        locality: this.locality,
        branch: this.branch,
        Servicedetails: this.ListOfSecondFields,
        orgId: this.orgId,
        created_By: this.userId,
        created_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
      };

      return this.http
        .post("/api/UpdateExistingService", reqObj)
        .subscribe(async (res) => {
          this.loading = false;
          let resProc = res.json();
          let nextSeviceType;
          for (let i = 0; i < this.ListOfCheckListMaster.length; i++) {
            if (
              parseInt(this.ListOfSecondFields[0].service_Type) ==
              this.ListOfCheckListMaster[i]._id
            ) {
              nextSeviceType = this.ListOfCheckListMaster[i].servicetype;
            }
          }

          // Load customer and machine details
          const { customerName, makeName, modelName } =
            await this.loadCustomerAndMachineDetails();

          let ReqObj = {
            SCHEDULE_DATE: this.ListOfSecondFields[0].date,
            userId: this.technicianName,
            MachineNumber: this.serialnumber,
            customerName: customerName, // Use fetched customer name
            phoneNumber: this.clientPhonenumber,
            machineMake: makeName, // Use fetched make name
            machineModel: modelName, // Use fetched model name
            PMId: resProc._id,
            RemainderDate: Remainder,
            CREATED_DATE: moment().format("YYYY-MM-DD"),
            lastserviceType: "This is First Service",
            lastserviceHmr: "This is First Service",
            nextserviceHmr: this.ListOfSecondFields[0].hmr,
            nextservicetype: nextSeviceType,
            nextServicedate: this.ListOfSecondFields[0].date,
            lastServiceDate: null,
            orgId: this.orgId,
            created_By: this.userId,
            created_Date: moment.utc().format("YYYY:MM:DD h:mm:ss"),
          };
          return this.http
            .post("/api/UpdatePMSNotifications", ReqObj)
            .subscribe((res) => {
              this.lastServiceStatus = false;
              $("#updatepop").modal("show");
            });
        });
    },
    (err) => {
      this.loading = false;
      this.msgtext = "Unable to Add the Data";
      this.getWarningFunction(this.msgtext);
    }
  );
}

  updateOK() {
    $("#updatepop").modal("hide");
    this.getEmptyAllField();
  }

  getWarningFunction(errMsg) {
    var toastOptions: ToastOptions = {
      title: "View page",
      msg: errMsg,
      showClose: true,
      timeout: 3000,
      theme: "bootstrap",
      onAdd: (toast: ToastData) => {},
      onRemove: function (toast: ToastData) {},
    };
    this.toastyService.warning(toastOptions);
  } //getWarningFunction end here

  getSuccessFunction(successMsg) {
    var toastOptions: ToastOptions = {
      title: "View page",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: "bootstrap",
      onAdd: (toast: ToastData) => {},
      onRemove: function (toast: ToastData) {},
    };
    this.toastyService.success(toastOptions);
  } //getSuccessFunction end here




async loadCustomerAndMachineDetails(): Promise<{
  customerName: string;
  makeName: string;
  modelName: string;
}> {
  let customerName = '';
  let makeName = '';
  let modelName = '';

  // Fetch customer name
  for (let i = 0; i < this.ListOfCustomermaster.length; i++) {
    if (this.ListOfCustomermaster[i]._id == parseInt(this.clientName)) {
      customerName = this.ListOfCustomermaster[i].customer_Name.toUpperCase();
      break;
    }
  }

  // Fetch make name
  for (let i = 0; i < this.ListMakeDetails.length; i++) {
    if (this.make == this.ListMakeDetails[i]._id) {
      makeName = this.ListMakeDetails[i].make.toUpperCase();
      break;
    }
  }

  // Fetch model name
  for (let i = 0; i < this.ListModelDetails.length; i++) {
    if (this.model == this.ListModelDetails[i]._id) {
      modelName = this.ListModelDetails[i].model.toUpperCase();
      break;
    }
  }

  // If model details are not loaded, fetch them based on make
  if (!modelName && this.make) {
    try {
      const res = await this.http
        .post('/api/getModeldetailsBasedOnMakeID', {
          MakeId: this.make,
          orgId: this.orgId,
        })
        .toPromise();
      const response = res.json();
      this.ListModelDetails = response;
      for (let i = 0; i < this.ListModelDetails.length; i++) {
        if (this.model == this.ListModelDetails[i]._id) {
          modelName = this.ListModelDetails[i].model.toUpperCase();
          break;
        }
      }
    } catch (err) {
      console.error('Error fetching model details:', err);
    }
  }

  return { customerName, makeName, modelName };
}




}



// WEBPACK FOOTER //
// ./client/app/preventive-maintenance/preventive-maintenance.component.ts